import {Utility} from './../../utility/util';
import {Injectable} from "@angular/core";
import {CoachingReportDataService} from "../../data-services/coaching/coaching.report.data.service";
import {BehaviorSubject, forkJoin, Observable, of} from "rxjs";
import {CoachingRating, CoachingReportStatus, CoachingTrackStatus, Report} from "../../classes/coaching/report.class";
import {AssessmentMatrix} from "../../classes/coaching/assessment-matrix.class";
import {AssessmentMeasure} from "../../classes/coaching/assessment.measure.class";
import {AssessmentCategory} from "../../classes/coaching/assessment-category.class";
import {DeviceService} from "../device/device.service";
import {LoadingController} from "@ionic/angular";
import {NotificationService, ToastStyle} from "../notification/notification.service";
import {ActivityDataService} from "../../data-services/activity/activity.service";

import {CoachingActivity} from "../../classes/coaching/activity.class";
import {ActivityService} from "../activity/activity.service";
import {AppointmentActivity} from "../../classes/activity/appointment.activity.class";
import {Activity, ActivityType} from "../../classes/activity/activity.class";
import {NavigationService} from "../navigation/navigation.service";
import {DiskService, OFFLINE_DATA_COUNT_ENTITY_NAME} from "../disk/disk.service";
import {DB_ALLDOCS_QUERY_OPTIONS, DB_KEY_PREFIXES, DB_SYNC_STATE_KEYS} from "../../config/pouch-db.config";
import {AssessmentRating} from "../../classes/coaching/assessment-rating.class";
import {AuthenticationService} from "../authentication.service";
import {FeatureActionsMap} from "../../classes/authentication/user.class";
import {User} from "../../classes/account/child.user.class";
import {EventsService} from "../events/events.service";
import {DeltaService, EntityNames, EntitySyncInfo} from "../../data-services/delta/delta.service";
import {Endpoints} from "../../../config/endpoints.config";
import {CoachingScale} from "../../classes/coaching/coaching.scale";
import {UIService} from "../ui/ui.service";
import { SyncProfilerService } from '../logging/sync-profiler.service';
import {TranslateService} from "@ngx-translate/core";
import {CoachingTemplate} from "../../classes/coaching/coaching-template.class";
import {CoachingTemplatesUser} from "../../classes/coaching/coaching-template-user.class";
import {AlertService} from "../alert/alert.service";
import {SelectedSuggestionPillDataModel} from '../../models/search-config-data-model';
import {SearchConfigService} from '../search/search-config.service';
import {map} from 'rxjs/operators';
import {PhoneActivity} from '@omni/classes/activity/phone.activity.class';
import { DatePipe } from '@angular/common';
import { DateTimeFormatsService } from '../date-time-formats/date-time-formats.service';
import { OrderActivity } from '@omni/classes/activity/order.activity.class';
import { IONote } from '@omni/classes/io/io-note.class';
import { fetchQueries } from '@omni/config/dynamics-fetchQueries';
import { CoachingPlan, CoachingPlanActivity } from '@omni/classes/coaching/coaching-plan.class';
import { cloneDeep, isEmpty, isNumber, uniqBy } from 'lodash-es';

export enum COACHING_VIEW_TYPE {
  FROM_PHONECALL,
  FROM_MEETING,
  FROM_TOOL,
  FROM_HOMESCREEN
}

@Injectable({
  providedIn: 'root'
})
export class CoachingReportService {

  public assessmentMatrix = new BehaviorSubject<AssessmentMatrix>(null);
  public coachingScales: Map<String, AssessmentRating[]> = new Map();
  public myReportSubject = new BehaviorSubject<Report[]>([]);
  private teamReportSubject = new BehaviorSubject<Report[]>([]);
  public reportByTabSubject = new BehaviorSubject<Report[]>([]);
  public selectedReport = new BehaviorSubject<Report>(null);
  private activityCoachingDataSource = new BehaviorSubject<Report[]>([]);
  public activityCoachingObserver = this.activityCoachingDataSource.asObservable();
  public  selectedCoachingPlanTab : Report;

  public reportByTabSubjectObs = this.reportByTabSubject.asObservable();

  public activeTab: string;
  // public activeFilter: number;
  public selectedCoachingFor: string = "";
  public display = false;
  public activityClick: boolean = false;
  public coachingReports: Report[] = [];
  public users: User[] = [];
  public coachingTemplatesUserMap: CoachingTemplatesUser[] = [];
  public coachingTemplates: CoachingTemplate[] = [];
  public userMappedCoachingTemplates: CoachingTemplate[] = [];
  public offlineCoachingReportIds = new Map(); // Hashmap to keep track offline coaching report data in local db

  public recentSearches: SelectedSuggestionPillDataModel[] = []; //Advanced search
  public teamRecentSearches: SelectedSuggestionPillDataModel[] = []; //Advanced search
  public coachingViewtype = COACHING_VIEW_TYPE.FROM_TOOL;
  public templateWeight: number = 0;
  public givenRatingsWeight: number = 0;
  private isInitialMappingDone: boolean = false;
  private isInitialMappingDoneForActivity: boolean = false;
  public coachingPlans: CoachingPlan[] = [];
  public coachingPlansActivity:CoachingPlanActivity[]  = [];
  public allActivity:CoachingActivity[]  = [];
  public observationValues = [{
    label: "Observed",
    value: 548910000
  },
  {
    label: "Not-Observed",
    value: 548910001
  },
  {
    label: "N/A",
    value: 548910002
  }];
  public overAllProcedureValues = [{
    label: "Yes",
    value: true
  },
  {
    label: "No",
    value: false
  }];
  public coachingTypes = [
    {
      label: "Initial",
      value: 548910000
    },
    {
      label: "Final",
      value: 548910001
    },
    {
      label: "Discussion Notes",
      value: 548910002
    },
    {
      label: "Field Travel Notes",
      value: 548910003
    }
  ];

  public overallRatings = [
    {
      label: "1. Poor knowledge of subject matter",
      value: 1
    },
    {
      label: "2. Limited knowledge of subject matter",
      value: 2
    },
    {
      label: "3. Strong knowledge of subject matter with clinically relevant gaps",
      value: 3
    },
    {
      label: "4. Solid knowledge of subject matter",
      value: 4
    },
    {
      label: "5. Complete knowledge of subject matter",
      value: 5
    }
  ];

  constructor(
    private coachingReportDataService: CoachingReportDataService,
    private alertService: AlertService,
    private deviceService: DeviceService,
    private loadingCtrl: LoadingController,
    private notificationService: NotificationService,
    private activityDataService: ActivityDataService,
    private activityService: ActivityService,
    private navService: NavigationService,
    private disk: DiskService,
    private authService: AuthenticationService,
    private events: EventsService,
    private deltaService: DeltaService,
    private uiService: UIService,
    public translate: TranslateService,
    private searchConfigService: SearchConfigService,
    private datePipe: DatePipe,
    private dateTimeFormatsService: DateTimeFormatsService,
    private readonly syncProfilerService: SyncProfilerService,
  ) {
  }

  addToOfflineCoachingReportsIds(id: String) {
    this.offlineCoachingReportIds.set(id, true);
  }

  deleteFromOfflineCoachingReportsIds(id: String) {
    this.offlineCoachingReportIds.delete(id);
  }

  hasOfflineCoachingReportsData(id: String) {
    return this.offlineCoachingReportIds.has(id);
  }

  public async loadAndMapCoachingReportFromDB() {
    if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_TOOL)) {
      // Await MY_COACHING first so its IDs are available as the definitive filter
      // when loading TEAM_COACHING records below.
      const myCoachingData: Report[] = await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_MY_COACHING) as Report[];
      myCoachingData.forEach(coaching => this.setMeasureCoachingScales(coaching));
      this.myReportSubject.next(myCoachingData);
      myCoachingData.forEach(myCoaching => this.mapMyCoachingFieldsToSearchIndex(myCoaching));
      console.log(`My coachings from disk : ${myCoachingData ? myCoachingData.length : 0}`);
      // Merge any unsynced offline self-coaching records so they survive an app restart.
      await this.mapOfflineSelfCoachingReports();

      if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_TEAM_VIEW)) {
        const currentUserId = this.authService.user.xSystemUserID;
        // Build a set of report IDs that are DEFINITIVELY the current user's own self-coaching
        // (coachee === current user). Used as a fallback for delta-sync records that may arrive
        // without indskr_coachingfor_value set. Intentionally scoped to coachee=currentUser only
        // so trainee self-coaching reports (coachee ≠ currentUser) are NOT excluded from the
        // team coaching list when they also appear in the MY_COACHING prefix.
        const selfCoachingIds = new Set(
          myCoachingData
            .filter(r => r.indskr_coachingreportid && r.indskr_coachingfor_value === currentUserId)
            .map(r => r.indskr_coachingreportid)
        );
        let teamCoachingReports: Report[] = [];
        await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_TEAM_COACHING).then(async (data: Report[]) => {
          // A record must be removed from TEAM_COACHING when it is the current user's own
          // self-coaching, identified by either:
          // 1. indskr_coachingfor_value === currentUserId  (present in full-sync responses)
          // 2. report ID is in selfCoachingIds             (fallback for lightweight delta responses)
          const isMyRecord = (r: Report) =>
            (currentUserId && r.indskr_coachingfor_value === currentUserId) ||
            selfCoachingIds.has(r.indskr_coachingreportid);
          const wrongRecords = data.filter(r => isMyRecord(r));
          for (const wrongRecord of wrongRecords) {
            await this.disk.remove(wrongRecord._id.toString())
              .catch(e => console.error('loadAndMapCoachingReportFromDB: failed to remove mis-stored record', wrongRecord._id, e));
          }
          const teamData = data.filter(r => !isMyRecord(r));
          teamData.forEach(coaching => this.setMeasureCoachingScales(coaching));
          teamCoachingReports = teamData;
          teamData.forEach(teamCoaching => this.mapTeamCoachingFieldsToSearchIndex(teamCoaching));
        });
        teamCoachingReports = await this.mapOfflineTeamReports(teamCoachingReports);
        this.teamReportSubject.next(teamCoachingReports);
        console.log(`Team coachings from disk : ${this.teamReportSubject.value.length}`)
        //Fetch Coaching templates from db
        this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_TEMPLATES).then((data: CoachingTemplate[]) => {
          this.coachingTemplates = data;
          console.log(`Coaching Templates from disk : ${data ? data.length : 0}`)
        });
      } else if (this.authService.hasFeatureAction(FeatureActionsMap.SELF_COACHING)
        && this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN)) {
        // Trainees without COACHING_TEAM_VIEW also need templates loaded from DB
        // so that self-coaching measures/categories can be populated
        this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_TEMPLATES).then((data: CoachingTemplate[]) => {
          this.coachingTemplates = data;
          console.log(`Coaching Templates from disk (self-coaching trainee): ${data ? data.length : 0}`);
        });
      }

      // For offline data tracking...
      this.checkOfflineDataExists();
    }
    this.fiterReports();
  }

  private async mapOfflineTeamReports(teamCoachingReports: Report[]): Promise<Report[]> {
    const offlineCoachingReports = await this.disk.loadOfflineCoachingReports();
    const currentUserId = this.authService.user.xSystemUserID;
    if (offlineCoachingReports && offlineCoachingReports['coachingReports'] && Array.isArray(offlineCoachingReports['coachingReports']) && offlineCoachingReports['coachingReports'].length > 0) {
      let offlineReports = offlineCoachingReports['coachingReports'];
      let offlineTeamReports: Report[] = offlineReports.filter(report =>
        !report.deleted &&
        report.statecode === 0 &&
        !(report as any)._isSelfCoaching &&
        report.indskr_coachingfor_value !== currentUserId
      ).map(report => report)
      offlineTeamReports.forEach(offlineTeamReport => {
        let idToBeUpdated = offlineTeamReport.offlineCoachingReportId ? offlineTeamReport.offlineCoachingReportId : offlineTeamReport.indskr_coachingreportid;
        this.setMeasureCoachingScales(offlineTeamReport);
        let index = this.teamReportSubject.value.findIndex((r: Report) => {
          return r.offlineCoachingReportId === idToBeUpdated || r.indskr_coachingreportid === idToBeUpdated;
        });
        if (index === -1) {
          teamCoachingReports = teamCoachingReports.concat(offlineTeamReport);
        } else {
          teamCoachingReports[index] = offlineTeamReport;
        }
      });
    }
    return teamCoachingReports;
  }

  private async mapOfflineSelfCoachingReports(): Promise<void> {
    const offlineCoachingReports = await this.disk.loadOfflineCoachingReports();
    if (!offlineCoachingReports || !Array.isArray(offlineCoachingReports['coachingReports'])) return;
    const currentUserId = this.authService.user.xSystemUserID;
    const offlineSelfReports: Report[] = offlineCoachingReports['coachingReports']
      .filter(report =>
        !report.deleted &&
        report.statecode === 0 &&
        ((report as any)._isSelfCoaching || (currentUserId && report.indskr_coachingfor_value === currentUserId))
      );
    if (offlineSelfReports.length === 0) return;
    let myReports: Report[] = [...this.myReportSubject.value];
    offlineSelfReports.forEach(offlineSelfReport => {
      const idToBeUpdated = offlineSelfReport.offlineCoachingReportId || offlineSelfReport.indskr_coachingreportid;
      this.setMeasureCoachingScales(offlineSelfReport);
      const index = myReports.findIndex(r =>
        r.offlineCoachingReportId === idToBeUpdated || r.indskr_coachingreportid === idToBeUpdated
      );
      if (index === -1) {
        myReports = myReports.concat(offlineSelfReport);
      } else {
        myReports[index] = offlineSelfReport;
      }
    });
    this.myReportSubject.next(myReports);
  }

  private setMeasureCoachingScales(coaching: Report) {
    // load/merge path calls — so new Date(...) / DatePipe never receive an unparseable string (NG02100).
    if (coaching) {
      if (coaching.indskr_periodstartdate) {
        coaching.indskr_periodstartdate = parseFloat(coaching.indskr_periodstartdate.toString());
      }
      if (coaching.indskr_periodenddate) {
        coaching.indskr_periodenddate = parseFloat(coaching.indskr_periodenddate.toString());
      }
      if (coaching.createdon) {
        coaching.createdon = parseFloat(coaching.createdon.toString());
      }
    }
    if (coaching.categories && coaching.categories.length > 0) {
      coaching.categories.forEach(category => {
        category.measures.forEach(measure => {
          measure.ratings = this.coachingScales.get(measure.ratingscale_id)
        })
      });
    }
  }

  public async loadOfflineCoachingReportsMasterData() {
    if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_TOOL)) {
      await this.getCoachingScales(true);
      if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_TEAM_VIEW)) {
        await this.getCoachingForUsers(true);
        await this.getCoachingTemplatesUsersMap(true);
      } else if (this.authService.hasFeatureAction(FeatureActionsMap.SELF_COACHING)
        && this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN)) {
        await this.getCoachingTemplatesUsersMap(true);
      }
    }
    await this.loadAndMapCoachingReportFromDB();
  }

  public async getCoachingReportsMasterData(loadFromDbOnly = false, profilerParentSpanId?: string) {
    if (loadFromDbOnly) {
      await this.loadOfflineCoachingReportsMasterData();
    } else {
      if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_TOOL)) {
        await this.syncProfilerService.timeAsync('coaching_scales', () => this.getCoachingScales(), profilerParentSpanId);
        await this.syncProfilerService.timeAsyncWithSpan('coaching_my_reports', (spanId) => this.getMyCoachingReports(spanId), profilerParentSpanId);
        await this.syncProfilerService.timeAsync('coaching_recent_searches', async () => { this.getMyRecentSearches(); }, profilerParentSpanId);
        if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_TEAM_VIEW)) {
          await this.syncProfilerService.timeAsync('coaching_for_users', () => this.getCoachingForUsers(), profilerParentSpanId);
          await this.syncProfilerService.timeAsyncWithSpan('coaching_team_reports', (spanId) => this.getTeamCoachingReports(spanId), profilerParentSpanId);
          await this.syncProfilerService.timeAsync('coaching_templates', () => this.getCoachingTemplates(), profilerParentSpanId);
          await this.syncProfilerService.timeAsync('coaching_team_recent_searches', async () => { this.getTeamRecentSearches(); }, profilerParentSpanId);
          await this.syncProfilerService.timeAsync('coaching_templates_users_map', () => this.getCoachingTemplatesUsersMap(), profilerParentSpanId);
        } else if (this.authService.hasFeatureAction(FeatureActionsMap.SELF_COACHING)
          && this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN)) {
          await this.syncProfilerService.timeAsync('coaching_templates', () => this.getCoachingTemplates(), profilerParentSpanId);
          await this.syncProfilerService.timeAsync('coaching_templates_users_map', () => this.getCoachingTemplatesUsersMap(), profilerParentSpanId);
        }
        this.loadAndMapCoachingReportFromDB();
      }

    }
  }

  public async getCoachingPlansMasterData(forceFullSync = false, loadFromDBOnly = false, profilerParentSpanId?: string) {
    if (loadFromDBOnly) {
      this.loadCoachingPlansFromDB();
      this.loadCoachingPlansActivityFromDB();
    } else {
      if (this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN)) {
        await this.syncProfilerService.timeAsync('coaching_plans_fetch', () => this.getCoachingPlans(forceFullSync), profilerParentSpanId);
        await this.syncProfilerService.timeAsync('coaching_plans_activities', () => this.getCoachingPlanActivities(forceFullSync), profilerParentSpanId);
      }
    }
  }

  private async getCoachingTemplatesUsersMap(loadFromDbOnly = false) {
    let offlineFallback: boolean = this.deviceService.isOffline || loadFromDbOnly;
    this.coachingTemplatesUserMap = [];
    if (offlineFallback) {
      await this.disk.retrieve(DB_KEY_PREFIXES.COACHING_TEMPLATE_USER_MAP).then(response => {
        if (response && response['raw']) {
          let map = response['raw'];
          if (map && map.length > 0) {
            map.map(rawJSON => {
              this.coachingTemplatesUserMap.push(new CoachingTemplatesUser(rawJSON));
            });
          }
        }
      }).catch(dbError => {
        console.log("Error retreiving coaching templates-users data from offline db!", dbError);
      });
    } else {
      try {
        const data: CoachingTemplatesUser[] = await this.coachingReportDataService.getCoachingTemplatesUsersMap().toPromise();
        if (Array.isArray(data)) {
          await this.disk.updateOrInsert(DB_KEY_PREFIXES.COACHING_TEMPLATE_USER_MAP, doc => ({ raw: data }))
            .catch((err) => console.error("getCoachingTemplatesUsersMap: Error saving coaching templates-users map data to offline db!", err));
          data.map(rawJSON => {
            this.coachingTemplatesUserMap.push(new CoachingTemplatesUser(rawJSON));
          });
        }
      } catch (error) {
        console.log("Error retreiving coaching templates-users data ", error);
      }
    }
  }

  private async getMyCoachingReports(profilerParentSpanId?: string) {
    const syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_MY_COACHING);
    const isInitialSync = !syncState || !syncState.lastUpdatedTime;
    const currentStamp = (new Date()).getTime()
    const newLastUpdatedTime = Utility.changeLocalDateToUTCDateWith0Time(currentStamp).getTime();
    const coachingReportSyncInfo: EntitySyncInfo = {
      entityName: EntityNames.coachingReport,
      totalFailed: 0,
      totalSynced: 0,
      errors: [],
      syncStatus: true
    };
    await this.syncProfilerService.timeAsync('coaching_my_reports_api',
      () => this.coachingReportDataService.getMyCoachingReports(isInitialSync, syncState.lastUpdatedTime),
      profilerParentSpanId).then(
      async (data: Report[]) => {
        await this.syncProfilerService.timeAsync('coaching_my_reports_processing', async () => {
          console.log("Saving my coachings to disk...");
          if(!isInitialSync) {
            data.forEach(o=>{
              if(o.statuscode == 1) {
                  o.track_action = CoachingTrackStatus.Removed;
              }
            })
          }
          await this.saveToDisk(isInitialSync, DB_KEY_PREFIXES.MY_COACHING, data);
          syncState.lastUpdatedTime = newLastUpdatedTime;
          await this.disk.updateSyncState(syncState);
          if (Array.isArray(data)) {
            coachingReportSyncInfo.totalSynced = data.length;
          }
          this.deltaService.addEntitySyncInfo(coachingReportSyncInfo);
          data.forEach(myCoaching => this.mapMyCoachingFieldsToSearchIndex(myCoaching));
          console.log(`Sync status : ${JSON.stringify(syncState)} initial sync : ${isInitialSync}`);
        }, profilerParentSpanId, data?.length);
      }).catch(err => {
        console.error("Error occurred while fetching my coachings...")
        this.deltaService.addSyncErrorToEntitySyncInfo(coachingReportSyncInfo, this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.coachingReports.GET_MY_COACHING_REPORTS, err);
        this.deltaService.addEntitySyncInfo(coachingReportSyncInfo);
      });
  }

  private async getTeamCoachingReports(profilerParentSpanId?: string) {
    const syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_TEAM_COACHING);
    const isInitialSync = !syncState || !syncState.lastUpdatedTime;
    const currentStamp = (new Date()).getTime()
    const newLastUpdatedTime = Utility.changeLocalDateToUTCDateWith0Time(currentStamp).getTime();// this.disk.getCurrentGMT0Timestamp();
    const teamCoachingReportSyncInfo: EntitySyncInfo = {
      entityName: EntityNames.teamCoachingReport,
      totalFailed: 0,
      totalSynced: 0,
      errors: [],
      syncStatus: true
    };

    const dataRange = this.authService.getFromToDateRangeInUTCMiliSec(undefined);
    const startDate = parseInt(dataRange.from);
    await this.syncProfilerService.timeAsync('coaching_team_reports_api',
      () => this.coachingReportDataService.getTeamCoachingReports(isInitialSync, newLastUpdatedTime, startDate),
      profilerParentSpanId).then(
      async (data: Report[]) => {
        console.log("Saving team coachings to disk...");
        // Exclude self-coaching records (coach = coachee = current user) from the team coaching list.
        // Use two signals to exclude the current user's OWN self-coaching from TEAM_COACHING:
        // 1. indskr_coachingfor_value === currentUserId (full-sync responses include this field)
        // 2. record is already in myReportSubject AND was coachee=currentUser (delta responses may
        //    omit unchanged fields; using only records where coachingfor=currentUser avoids
        //    incorrectly filtering out trainee self-coaching reports that the trainer should see).
        const currentUserId = this.authService.user.xSystemUserID;
        const selfCoachingIds = new Set(this.myReportSubject.value
          .filter(r => r.indskr_coachingreportid && r.indskr_coachingfor_value === currentUserId)
          .map(r => r.indskr_coachingreportid));
        const teamOnlyData = data.filter(r =>
          r.indskr_coachingfor_value !== currentUserId &&
          !selfCoachingIds.has(r.indskr_coachingreportid)
        );
        await this.syncProfilerService.timeAsync('coaching_team_reports_processing', async () => {
          await this.saveToDisk(isInitialSync, DB_KEY_PREFIXES.TEAM_COACHING, teamOnlyData);
          syncState.lastUpdatedTime = newLastUpdatedTime;
          await this.disk.updateSyncState(syncState);
          if (Array.isArray(data)) {
            teamCoachingReportSyncInfo.totalSynced = data.length;
          }
          this.deltaService.addEntitySyncInfo(teamCoachingReportSyncInfo);
          // For Advanced Search
          teamOnlyData.forEach(teamCoaching => this.mapTeamCoachingFieldsToSearchIndex(teamCoaching));
          console.log(`Sync status : ${JSON.stringify(syncState)} initial sync : ${isInitialSync}`);
        }, profilerParentSpanId, data?.length);
      }).catch(err => {
        console.error("Error occurred while fetching team coachings...")
        this.deltaService.addSyncErrorToEntitySyncInfo(teamCoachingReportSyncInfo, this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.coachingReports.GET_TEAM_COACHING_REPORTS, err);
        this.deltaService.addEntitySyncInfo(teamCoachingReportSyncInfo);
      });
  }

  private async getCoachingTemplates() {
    const syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_COACHING_TEMPLATES);
    const isInitialSync = !syncState || !syncState.lastUpdatedTime || this.authService.shouldContentFullSync;
    const newLastUpdatedTime = new Date().getTime();
    const coachingTemplatesSyncInfo: EntitySyncInfo = {
      entityName: EntityNames.coachingTemplate,
      totalFailed: 0,
      totalSynced: 0,
      errors: [],
      syncStatus: true
    };
    if (isInitialSync) {
      await this.disk.deleteAllFromDbUsingAlldocsQuery(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_TEMPLATES);
    }
    await this.coachingReportDataService.getCoachingTemplates(isInitialSync, syncState.lastUpdatedTime).then(
      async (data: CoachingTemplate[]) => {
        console.log("Saving coaching templates to disk...");
        await this.saveCoachingTemplatesToDisk(isInitialSync, data);
        // Populate in-memory immediately so updateCoaching (isSelfCoaching) can find templates
        // without waiting for the async batchFetch in loadAndMapCoachingReportFromDB
        if (Array.isArray(data)) {
          this.coachingTemplates = data;
          coachingTemplatesSyncInfo.totalSynced = data.length;
        }
        syncState.lastUpdatedTime = newLastUpdatedTime;
        await this.disk.updateSyncState(syncState);
        this.deltaService.addEntitySyncInfo(coachingTemplatesSyncInfo);
        console.log(`Sync status : ${JSON.stringify(syncState)} initial sync : ${isInitialSync}`);
      }).catch(err => {
        console.error("Error occurred while fetching coaching templates...", err)
        this.deltaService.addSyncErrorToEntitySyncInfo(coachingTemplatesSyncInfo, this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.coachingReports.GET_COACHING_TEMPLATES, err);
        this.deltaService.addEntitySyncInfo(coachingTemplatesSyncInfo);
      });
  }

  private async saveCoachingTemplatesToDisk(isInitialSync: boolean, data: CoachingTemplate[]) {
    if (data && data.length > 0) {
      if (!isInitialSync) {
        data.forEach((template: CoachingTemplate) => {
          template._id = DB_KEY_PREFIXES.COACHING_TEMPLATES + template.indskr_coachingtemplateid;
          if (!isInitialSync) {
            if (template.track_action == 548910001) {
              this.disk.retrieve(template._id.toString()).then(async (exist) => {
                if (exist) await this.disk.remove(template._id.toString());
              });
            } else {
              this.disk.retrieve(template._id.toString()).then(async (exist) => {
                if (!exist) {
                  await this.disk.updateOrInsert(template._id.toString(), doc => template)
                    .catch(error => console.error('CoachingService: saveCoachingTemplatesToDisk: ', error));
                } else {
                  exist = {
                    ...exist,
                    indskr_coachingtemplateid: template.indskr_coachingtemplateid,
                    categories: template.categories
                  }
                  await this.disk.updateOrInsert(template._id.toString(), doc => exist)
                    .catch(error => console.error('CoachingService: saveCoachingTemplatesToDisk: ', error));
                }
              }, err => {
                console.log("CoachingService: saveCoachingTemplatesToDisk: Error occurred" + err);
              });
            }
          }
        });
      }
      else {
        data.forEach((template: CoachingTemplate) => {
          template._id = DB_KEY_PREFIXES.COACHING_TEMPLATES + template.indskr_coachingtemplateid;
        });
        this.disk.bulk(data);
      }
    }
    console.log(`${data.length} coaching template(s) has been written to disk`)
  }

  private async saveToDisk(isInitialSync, dbKey, data: Report[]) {
    if (!(data && data.length > 0)) return;

    let existingCoachingsById: Map<string, Report> | null = null;
    if (!isInitialSync) {
      const coachingIds = data.map(incomingCoaching => dbKey + incomingCoaching.indskr_coachingreportid);
      existingCoachingsById = await this.bulkRetrieveExistingCoachings(coachingIds);
    }

    const coachingsToUpsert: any[] = [];
    const coachingsToDelete: any[] = [];

    for (let index = 0; index < data.length; index++) {
      let coaching = data[index];
      coaching._id = dbKey + coaching.indskr_coachingreportid;

      if (coaching.statuscode == 548910000) {
        const existingCoaching = existingCoachingsById
          ? existingCoachingsById.get(coaching._id.toString())
          : await this.disk.retrieve(coaching._id.toString());
        if (existingCoaching) {
          coaching = existingCoaching;
          coaching.statusName = "Acknowledged";
          coaching.statuscode = 548910000;
          coaching.statecode = 1;
        }
        if (coaching.track_action === CoachingTrackStatus.Removed) {
          await this.disk.retrieve(coaching._id.toString()).then(async (exist) => {
            if (exist) await this.disk.remove(coaching._id.toString());
          });
          continue;
        }
        {
          if (coaching.indskr_periodstartdate) {
            coaching.indskr_periodstartdate = parseFloat(coaching.indskr_periodstartdate.toString());
          }
          if (coaching.indskr_periodenddate) {
            coaching.indskr_periodenddate = parseFloat(coaching.indskr_periodenddate.toString());
          }
          if (coaching.createdon) {
            coaching.createdon = parseFloat(coaching.createdon.toString());
          }
          if (coaching.categories && coaching.categories.length > 0) this.applyMinAndMaxRatings(coaching);
          else {
            coaching.min_rating = new CoachingRating();
            coaching.max_rating = new CoachingRating();
          }
          const isCurrentlySelected = this.selectedReport.value && (
            this.selectedReport.value.offlineCoachingReportId === coaching.offlineCoachingReportId ||
            (this.selectedReport.value.indskr_coachingreportid && this.selectedReport.value.indskr_coachingreportid.length > 0
              && this.selectedReport.value.indskr_coachingreportid === coaching.indskr_coachingreportid));
          if (!isInitialSync) {
            await this.disk.retrieve(coaching._id.toString()).then(async (exist) => {
              if (!exist) {
                await this.disk.updateOrInsert(coaching._id.toString(), doc => coaching);
                if (isCurrentlySelected) {
                  this.setMeasureCoachingScales(coaching);
                  this.selectedReport.next(coaching);
                }
              } else {
                let mergedCoaching: Report;
                if (dbKey === DB_KEY_PREFIXES.TEAM_COACHING) {
                  exist.indskr_coachingfor_value = coaching.indskr_coachingfor_value;
                  exist.created_for = coaching.created_for;
                  exist.created_for_firstname = coaching.created_for_firstname;
                  exist.indskr_name = coaching.indskr_name;
                  mergedCoaching = await this.updateSelectedCoachingInDB(exist, coaching);
                } else {
                  mergedCoaching = await this.updateSelectedCoachingInDB(exist, coaching);
                }
                if (mergedCoaching) {
                  this.updateCoachingDetails(mergedCoaching, isCurrentlySelected);
                }
              }
            }, err => {
              console.log("Error occurred" + err);
            });
          } else {
            const existingInDb = await this.disk.retrieve(coaching._id.toString());
            if (existingInDb) {
              if (dbKey === DB_KEY_PREFIXES.TEAM_COACHING) {
                existingInDb.indskr_coachingfor_value = coaching.indskr_coachingfor_value;
                existingInDb.created_for = coaching.created_for;
                existingInDb.created_for_firstname = coaching.created_for_firstname;
                existingInDb.indskr_name = coaching.indskr_name;
              }
              const mergedCoaching = await this.updateSelectedCoachingInDB(existingInDb, coaching);
              if (mergedCoaching) {
                (coaching as any)._mergedDuringInitialSync = true;
                if (isCurrentlySelected) {
                  this.setMeasureCoachingScales(mergedCoaching);
                  this.selectedReport.next(mergedCoaching);
                }
              }
            } else {
              if (isCurrentlySelected) {
                this.setMeasureCoachingScales(coaching);
                this.selectedReport.next(coaching);
              }
            }
          }
        }
      }
      if (isInitialSync) {
        const newRecords = data.filter(r => !(r as any)._mergedDuringInitialSync);
        if (newRecords.length > 0) {
          // Deduplicate activity arrays before bulk-inserting: the list-sync FetchXML may
          // return the same activity ID more than once due to stale junction-table join
          // results. A uniq-by-id guard prevents the same activity showing twice in the
          // initial display before checkCoachingOnline corrects the data from the
          // per-record endpoint.
          newRecords.forEach(r => {
            if (Array.isArray(r.meetings)) {
              r.meetings = uniqBy(r.meetings, 'indskr_activityid');
            }
            if (Array.isArray(r.phonecalls)) {
              r.phonecalls = uniqBy(r.phonecalls, 'indskr_activityid');
            }
            if (Array.isArray(r.procedureLogs)) {
              r.procedureLogs = uniqBy(r.procedureLogs, 'indskr_activityid');
            }
          });
          await this.disk.bulk(newRecords);
        }
      }
      console.log(`${data.length} coachings has been written to disk`)
    }

    if (isInitialSync) {
      await this.disk.bulk(data);
    } else {
      if (coachingsToUpsert.length > 0) await this.disk.bulkInChunks(coachingsToUpsert);
      if (coachingsToDelete.length > 0) await this.disk.bulkInChunks(coachingsToDelete);
    }
    console.log(`${data.length} coachings has been written to disk`);
  }

  private async bulkRetrieveExistingCoachings(coachingIds: string[]): Promise<Map<string, Report>> {
    const existingCoachingsById = new Map<string, Report>();
    if (!coachingIds || coachingIds.length === 0) return existingCoachingsById;
    const READ_CHUNK_SIZE = 500;
    for (let offset = 0; offset < coachingIds.length; offset += READ_CHUNK_SIZE) {
      const coachingIdsBatch = coachingIds.slice(offset, offset + READ_CHUNK_SIZE);
      try {
        const fetchedCoachings = await this.disk.batchFetch({ keys: coachingIdsBatch, include_docs: true }, true) as any[];
        if (Array.isArray(fetchedCoachings)) {
          for (const fetchedCoaching of fetchedCoachings) {
            if (fetchedCoaching && fetchedCoaching._id) existingCoachingsById.set(fetchedCoaching._id, fetchedCoaching);
          }
        }
      } catch (error) {
        console.error('saveToDisk: bulkRetrieveExistingCoachings failed', error);
      }
    }
    return existingCoachingsById;
  }

  private async getCoachingScales(loadFromDbOnly = false) {
    let offlineFallback: boolean = this.deviceService.isOffline || loadFromDbOnly;
    const coachingScaleSyncInfo: EntitySyncInfo = {
      entityName: EntityNames.coachingScales,
      totalFailed: 0,
      totalSynced: 0,
      errors: [],
      syncStatus: true
    };
    if (!offlineFallback) {
      try {
        let scales: CoachingScale[] = await this.syncProfilerService.timeAsync('coaching_scales_api',
          () => this.coachingReportDataService.getCoachingScales().toPromise());
        await this.syncProfilerService.timeAsync('coaching_scales_processing', async () => {
          if (Array.isArray(scales)) {
            coachingScaleSyncInfo.totalSynced = scales.length;
          }
          await this.disk.updateOrInsert(DB_KEY_PREFIXES.COACHING_SCALES, doc => ({ raw: scales }))
            .catch(error => console.error('getCoachingScales: Error saving coaching scales data to offline db!', error));
          if (scales && scales.length > 0) {
            scales.forEach(scale => {
              this.coachingScales.set(scale.ratingscale_id, scale.ratings);
            });
          }
        }, undefined, scales?.length);
      } catch (error) {
        offlineFallback = true;
        this.deltaService.addSyncErrorToEntitySyncInfo(coachingScaleSyncInfo, this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.coachingReports.GET_COACHING_SCALES, error);
      }
      this.deltaService.addEntitySyncInfo(coachingScaleSyncInfo);
    }
    if (offlineFallback) {
      await this.disk.retrieve(DB_KEY_PREFIXES.COACHING_SCALES).then(response => {
        if (response && response['raw']) {
          let scales = response['raw'];
          if (scales && scales.length > 0) {
            scales.forEach(scale => {
              this.coachingScales.set(scale.ratingscale_id, scale.ratings);
            });
          }
        }
      }).catch(dbError => {
        console.log("Error retreiving coaching scales data from offline db!", dbError);
      });
    }
  }

  private async getCoachingPlans(forceFullSync: boolean) {
    let fetchXml = fetchQueries.coaching.coachingPlans;

    // When Self Coaching FA is on, include plans where the logged-in user is the trainee
    // in addition to plans where they are a trainer (via the N:N associated users table)
    const hasSelfCoachingFA = this.authService.hasFeatureAction(FeatureActionsMap.SELF_COACHING);
    const userAccessCondition = hasSelfCoachingFA
      ? `<filter type="or">
          <condition attribute="indskr_trainee" operator="eq-userid" />
          <condition entityname="ab" attribute="systemuserid" operator="eq-userid" />
        </filter>`
      : `<condition entityname="ab" attribute="systemuserid" operator="eq-userid" />`;
    fetchXml = fetchXml.replace('{UserAccessCondition}', userAccessCondition);

    const syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_COACHING_PLANS);
    const isInitialSync = forceFullSync || !syncState || !syncState.lastUpdatedTime;
    const newLastUpdatedTime = new Date().getTime();

    const coachingPlanSyncInfo: EntitySyncInfo = {
      entityName: EntityNames.coachingPlans,
      totalFailed: 0,
      totalSynced: 0,
      errors: [],
      syncStatus: true
    };
    const validity = this.dateTimeFormatsService.formatDate(newLastUpdatedTime, 'YYYY-MM-DDTHH:mm:ss');
    if (isInitialSync) {
      this.coachingPlans = [];
      fetchXml = fetchXml.replace('{DeltaCondition}', '');
      try{
        Promise.all([
          this.disk.deleteAllFromDbUsingAlldocsQuery(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_PLANS),
          this.deleteCoachingPlans([], true),
        ]);
      }catch(error) {
        console.error("Failed to delete coachingplans ", error);
      }
    }
    else {
      const deltaSyncFilter = `<condition attribute="modifiedon" operator="ge" value="` + new Date(syncState.lastUpdatedTime).toISOString() + `" />`
      fetchXml = fetchXml.replace('{DeltaCondition}', deltaSyncFilter);
      if (!this.isInitialMappingDone) {
        await this.loadCoachingPlansFromDB();
        this.isInitialMappingDone = true;
      }
    }

    await this.coachingReportDataService.getCoachingPlans(fetchXml).then(
      async (data: CoachingPlan[]) => {
        if (!isEmpty(data)) {
          console.log("Saving coaching plans to disk...");
          this.removeUnderscoreFromDynamicsResp(data);
          if (isInitialSync) {
            await this.saveCoachingPlansToDisk(data);
          } else {
            await this.saveDeltaCoachingPlansToDisk(data);
          }
        }
        this.isInitialMappingDone = true;
        syncState.lastUpdatedTime = newLastUpdatedTime;
        await this.disk.updateSyncState(syncState);
        if (Array.isArray(data)) {
          coachingPlanSyncInfo.totalSynced = data.length;
        }
        this.deltaService.addEntitySyncInfo(coachingPlanSyncInfo);
      }).catch(err => {
        console.error("Error occurred while fetching coachingplans...", err)
        this.deltaService.addSyncErrorToEntitySyncInfo(coachingPlanSyncInfo, 'indskr_coachingplans', err);
        this.deltaService.addEntitySyncInfo(coachingPlanSyncInfo);
      });
  }

  private removeUnderscoreFromDynamicsResp(res: any) {
    for (let i = 0; i < res.length; i++) {
      const rawCase = res[i];
      for (let key in res[i]) {
        if (key.charAt(0) === "_") {
          var a = key.substring(1, key.length);
          res[i][a] = rawCase[a] = res[i][key];
          delete res[i][key];
          delete rawCase[key];
        }
      }
    }
  }

  public async deleteCoachingPlans(deletedTemplateIds: string[], clearAll: boolean = false) {
    if (clearAll) {
      await this.disk.deleteAllFromDbUsingAlldocsQuery(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_CUST_ASSESSMENTS);
    } else {
      const deletedCoachingPlans = [];
      const coachingPlans: CoachingPlan[] = await this.getAllCoachingPlans();
      coachingPlans.forEach(coachingPlan => {
        if (deletedTemplateIds.includes(coachingPlan.indskr_coachingplanid)) {
          deletedCoachingPlans.push({ _id: coachingPlan._id, _rev: coachingPlan._rev, _deleted: true });
        }
      });
      if (!isEmpty(deletedCoachingPlans)) {
        await this.disk.bulk(deletedCoachingPlans);
      }
    }
  }

  private async getAllCoachingPlans(): Promise<CoachingPlan[]> {
    return await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_PLANS).then((data: CoachingPlan[]) => {
      return data;
    });
  }

  private async getCoachingForUsers(loadFromDbOnly = false) {
    let offlineFallback: boolean = this.deviceService.isOffline || loadFromDbOnly;
    this.users = [];
    const userCoachingSyncInfo: EntitySyncInfo = {
      entityName: EntityNames.assessmentMatrix,
      totalFailed: 0,
      totalSynced: 0,
      errors: [],
      syncStatus: true
    };
    if (!offlineFallback) {
      try {
        const data: User[] = await this.syncProfilerService.timeAsync('coaching_for_users_api',
          () => this.coachingReportDataService.getCoachingForUsers().toPromise());
        await this.syncProfilerService.timeAsync('coaching_for_users_processing', async () => {
          if (Array.isArray(data)) {
            userCoachingSyncInfo.totalSynced = data.length;
            await this.disk.updateOrInsert(DB_KEY_PREFIXES.COACHING_USERS, doc => ({ raw: data }))
              .catch((err) => console.error("getCoachingForUsers: Error saving coaching users data to offline db!", err));

            data.map(rawJSON => {
              this.users.push(new User(rawJSON));
            });
          }
        }, undefined, data?.length);
      } catch (error) {
        offlineFallback = true;
        this.deltaService.addSyncErrorToEntitySyncInfo(userCoachingSyncInfo, this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.coachingReports.GET_COACHING_FOR_USERS, error);
      }
      this.deltaService.addEntitySyncInfo(userCoachingSyncInfo);
    }
    if (offlineFallback) {
      await this.disk.retrieve(DB_KEY_PREFIXES.COACHING_USERS).then(response => {
        if (response && response['raw']) {
          let users = response['raw'];
          if (users && users.length > 0) {
            users.map(rawJSON => {
              this.users.push(new User(rawJSON));
            });
          }
        }
      }).catch(dbError => {
        console.log("Error retreiving coaching users data from offline db!", dbError);
      });
    }
  }

  private async saveCoachingPlansToDisk(data: CoachingPlan[]) {
    for (let i = 0; i < data.length; i++) {
      const rawData = data[i];
      /* Pouch db doesnt allow to store keyword starting with _ */
      for (let key in data[i]) {
        if (key.charAt(0) === "_") {
          var a = key.substring(1, key.length);
          data[i][a] = rawData[a] = data[i][key];
          delete data[i][key];
          delete rawData[key];
        }
      }
      rawData['_id'] = DB_KEY_PREFIXES.COACHING_PLANS + rawData['indskr_coachingplanid'];
      this.coachingPlans.push(rawData);
      try {
        await this.disk.bulk(this.coachingPlans);
      } catch (error) {
        console.log("error saving bulk coaching plans", error);
      }
    }
  }
  private async saveCoachingPlansActivityToDisk(data: CoachingPlanActivity[]) {
    for (let i = 0; i < data.length; i++) {
      const rawData = data[i];
      /* Pouch db doesnt allow to store keyword starting with _ */
      for (let key in data[i]) {
        if (key.charAt(0) === "_") {
          var a = key.substring(1, key.length);
          data[i][a] = rawData[a] = data[i][key];
          delete data[i][key];
          delete rawData[key];
        }
      }
      rawData['_id'] = DB_KEY_PREFIXES.COACHING_PLANS_ACTIVITY + rawData['indskr_coachingplanactivityid'];
      // if(rawData['_id'] ||rawData['_id'])
      this.coachingPlansActivity.push(rawData);
      try {
        await this.disk.bulk(this.coachingPlansActivity);
      } catch (error) {
        console.log("error saving bulk coaching plans Activity", error);
      }
    }
  }

  private async saveDeltaCoachingPlansToDisk(data: CoachingPlan[]) {
    const deletedCoachingPlans = [];
    const deletedCoachingPlanIds = [];
    for (let template of data) {
      template._id = DB_KEY_PREFIXES.COACHING_PLANS + template['indskr_coachingplanid'];
      const index = this.coachingPlans.findIndex(assessTemplate => assessTemplate.indskr_coachingplanid === template.indskr_coachingplanid);
      if (template.statuscode === 548910001) {
        if (index > -1) {
          this.coachingPlans[index] = template;
        } else {
          this.coachingPlans.push(template);
        }
        await this.disk.updateOrInsert(template._id, (doc) => { return template; });
      } else {
        //Delete DB Record is presenet if only present in DB
        if (index > -1) {
          deletedCoachingPlans.push({ _id: this.coachingPlans[index]._id, _rev: this.coachingPlans[index]._rev, _deleted: true });
          deletedCoachingPlanIds.push(this.coachingPlans[index].indskr_coachingplanid);
          this.coachingPlans.splice(index, 1);
        }
      }
    }
    if (!isEmpty(deletedCoachingPlans)) {
      try {
        // Bulk save/update docs to DB
        await this.disk.bulk(deletedCoachingPlans);
        this.deleteCoachingPlans(deletedCoachingPlans)
      } catch (error) {
        console.error('error occurred: saving deleted coaching plans: ', error);
      }
    }

  }
  private async saveDeltaCoachingPlansActivityToDisk(data: CoachingPlanActivity[]) {
    const deletedCoachingPlansActivity = [];
    const deletedCoachingPlanActivityIds = [];
    for (let template of data) {
      template._id = DB_KEY_PREFIXES.COACHING_PLANS_ACTIVITY + template['indskr_coachingplanactivityid'];
      console.log( this.coachingPlansActivity);
      const index = this.coachingPlansActivity.findIndex(assessTemplate => assessTemplate.indskr_coachingplanactivityid === template["indskr_coachingplanactivityid"]);
      if (true) {
        if (index > -1) {
          this.coachingPlansActivity[index] = template;
        } else {
          this.coachingPlansActivity.push(template);
        }
        await this.disk.updateOrInsert(template._id, (doc) => { return template; });
      } else {
        //Delete DB Record is presenet if only present in DB
        if (index > -1) {
          deletedCoachingPlansActivity.push({ _id: this.coachingPlansActivity[index]._id, _rev: this.coachingPlansActivity[index]._rev, _deleted: true });
          deletedCoachingPlanActivityIds.push(this.coachingPlansActivity[index].indskr_coachingplanactivityid);
          this.coachingPlansActivity.splice(index, 1);
        }
      }
    }
    if (!isEmpty(deletedCoachingPlansActivity)) {
      try {
        // Bulk save/update docs to DB
        await this.disk.bulk(deletedCoachingPlansActivity);
        this.deleteCoachingPlans(deletedCoachingPlansActivity)
      } catch (error) {
        console.error('error occurred: saving deleted coaching plans: ', error);
      }
    }

  }

  public async loadCoachingPlansFromDB() {
    //Fetch Coaching Plans from db
    await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_PLANS).then((data: CoachingPlan[]) => {
      if (!isEmpty(data)) {
        this.coachingPlans = data.filter(d => d.statuscode == 548910001);
        console.log(`Coaching Plans from disk : ${this.coachingPlans ? this.coachingPlans.length : 0}`);
      }
    });
  }
  public async loadCoachingPlansActivityFromDB() {
    //Fetch Coaching Plans from db
    await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_PLANS_ACTIVITY).then((data: CoachingPlanActivity[]) => {
      if (!isEmpty(data)) {
        this.coachingPlansActivity = data;//.filter(d => d.statuscode == 548910001);
        console.log(`Coaching Plans Activity from disk : ${this.coachingPlansActivity ? this.coachingPlansActivity.length : 0}`);
      }
    });
  }

  public getTeamCoachingActivities(isInitialCreateCoaching?:boolean ,indskr_coachingplan?): Observable<CoachingActivity[]> {
    const report: Report = this.selectedReport.value;
    if (!report) return of([]);
    let startTime:number ;
    let endTime ;
     startTime = this.dateTimeFormatsService.getStartOfDay(report.indskr_periodstartdate).getTime();
     endTime = this.dateTimeFormatsService.getEndOfDay(report.indskr_periodenddate).getTime();

    const user = this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN) ? this.authService.user.xSystemUserID : report.indskr_coachingfor_value;
  //  if(!isInitialCreateCoaching){
    if (this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN) && report.indskr_coachingplan ) {
      const coachingPlan = this.coachingPlans.find(e => e.indskr_coachingplanid == report.indskr_coachingplan);
      const planStart = coachingPlan?.indskr_approvaldate ? new Date(coachingPlan.indskr_approvaldate).getTime() : NaN;
      if (!isNaN(planStart)) startTime = planStart;
    }
    if(indskr_coachingplan){
      const coachingPlan = this.coachingPlans.find(e => e.indskr_coachingplanid == indskr_coachingplan);
      const planStart = coachingPlan?.indskr_approvaldate ? new Date(coachingPlan.indskr_approvaldate).getTime() : NaN;
      if (!isNaN(planStart)) startTime = planStart;
    }

  //  }
    const source = [
      this.coachingReportDataService.getTeamCoachingAppointments(user, startTime, endTime)
    ];
    if (this.authService.hasFeatureAction(FeatureActionsMap.PHONECALL_ACTIVITY)) {
      source.push(this.coachingReportDataService.getTeamCoachingPhoneCalls(user, startTime, endTime ))
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN)) {
      source.push(this.coachingReportDataService.getTeamCoachingProcedureLogs(user, startTime, endTime))
    }
    let res$ = forkJoin(source).pipe(
      map(([appointments, phonecalls, procedurelogs]) => {
        const result = [];
        if (!isEmpty(appointments)) {
          appointments.map(ap => ap.activityType = ActivityType.Appointment);
          result.push(...appointments);
        }
        if (!isEmpty(phonecalls)) {
          phonecalls.map(ph => ph.phonenumber ? ph.activityType = ActivityType.PhoneCall : ph.activityType = ActivityType.SurgeryOrder);
          result.push(...phonecalls);
        }
        if (!isEmpty(procedurelogs)) {
          procedurelogs.map(ph => ph.activityType = ActivityType.SurgeryOrder);
          result.push(...procedurelogs);
        }
        return result;
      })
    );
    //try
    if (!isInitialCreateCoaching) {
      let activeActivityIds: any[] = [];
      let relatedActivity: any[] = [];
      const coachPlanActivityGroupBy = this.sortCoachingPlanIdWithActivityId(this.coachingPlansActivity);
      let activity = coachPlanActivityGroupBy[this.selectedReport.value.indskr_coachingplan];
      if (activity && activity.length > 0) {
        activeActivityIds = activity.map(res => res["indskr_meeting_value"] || res["indskr_procedurelog_value"]);
      }
      if(activeActivityIds  && activeActivityIds.length > 0){
        activeActivityIds.forEach(data => {
          res$.subscribe((res: any[]) => {
            let act = res.find(x => x.indskr_activityid == data)
            if (act) relatedActivity.push(act);
          });
        });
        return of(relatedActivity);
      }
      else{
        return res$;
      }
    } else {
      return res$;
    }


  }

  public fiterReports() {
    let reports: Report[] = [];
    if (this.activeTab === 'myCoaching') {
      reports = this.myReportSubject.value;
    } else {
      reports = this.teamReportSubject.value;
    }
    this.reportByTabSubject.next(reports);
    // if (this.activeFilter == 0) {
    //   this.reportByTabSubject.next(reports);
    // } else {
    //   if (this.activeFilter === 1) {
    //     //On Filter: Open - Open reports and offline submitted FOR REVIEW
    //     this.reportByTabSubject.next(reports.filter((report: Report) => (report.statuscode == this.activeFilter || report.statuscode === 2)));
    //   }
    //   else if (this.activeFilter === 548910001) {
    //     //On Filter: Ack - Ack reports and offline submitted Ackn
    //     this.reportByTabSubject.next(reports.filter((report: Report) => (report.statuscode == this.activeFilter || report.statuscode === 3)));
    //   } else {
    //     this.reportByTabSubject.next(reports.filter((report: Report) => report.statuscode == this.activeFilter));
    //   }
    // }
  }

  public acceptReport() {
    let report: Report = this.selectedReport.value;
    if (report.statuscode !== 548910002 || this.activeTab !== 'myCoaching') return;

    this.alertService.showAlert({
        header: this.translate.instant('COACHING_ACCEPT'),
        message: this.translate.instant('COACHING_R_U_SURE_WANT_ACCEPT')
      },
      this.translate.instant('CONFIRM')
    ).then(async res => {
      if (res.role == "ok") {
        let payload = {
          statuscode: 548910003,
          "indskr_accepteddate": new Date().getTime()
        };
        if (this.isOffline(report)) {
          payload['indskr_coachingreportid'] = report.indskr_coachingreportid;
          if (report.offlineCoachingReportId)
            payload['offlineCoachingReportId'] = report.offlineCoachingReportId
          this.acceptReportOffline(payload, report);
        } else {
          const loader = await this.loadingCtrl.create();
          loader.present();
          this.coachingReportDataService.updateReport(report.indskr_coachingreportid, payload)
            .then(
              res => {
                // report.statecode = 1;
                report.statuscode = 548910003;
                this.selectedReport.next(report);
                let reports = this.myReportSubject.value;
                let currentReport = reports.find(data => data.indskr_coachingreportid === report.indskr_coachingreportid);
                currentReport.statuscode = 548910003;
                currentReport.statusName = "Accepted";
                let acceptedDate = new Date(payload.indskr_accepteddate);
                currentReport.indskr_accepteddate = acceptedDate.toString();
                this.myReportSubject.next(reports);
                this.events.publish('coaching-updated', currentReport);
                this.disk.retrieve(report._id.toString()).
                then((existingCoaching: Report) => {
                  existingCoaching.statuscode = report.statuscode;
                  existingCoaching.statusName = "Accepted";
                  existingCoaching.indskr_accepteddate = report.indskr_accepteddate;
                  this.disk.updateOrInsert(report._id.toString(), doc => existingCoaching);
                });
                this.fiterReports();
                loader.dismiss();
              },
              msg => {
                this.checkCoachingError(msg, report);
                loader.dismiss();
              }
            );
        }
      }
    });
  }

  public acknowledgeReport() {
    let report: Report = this.selectedReport.value;
    if (report.statuscode !== 548910001 || this.activeTab !== 'myCoaching') return;

    this.alertService.showAlert({
      header: this.translate.instant('COACHING_ACKNOWLEDGE'),
      message: this.translate.instant('COACHING_R_U_SURE_WANT_ACKNOWLEDGE')
    },
      this.translate.instant('ACKNOWLEDGE')
    ).then(async res => {
      if (res.role == "ok") {
        let payload = { indskr_dateacknowledged: new Date().getTime(), statuscode: 548910000, statecode: 1 };
        if (this.isOffline(report)) {
          payload['indskr_coachingreportid'] = report.indskr_coachingreportid;
          if (report.offlineCoachingReportId)
            payload['offlineCoachingReportId'] = report.offlineCoachingReportId
          this.acknowledgeReportOffline(payload, report);
        } else {
          const loader = await this.loadingCtrl.create();
          loader.present();
          this.coachingReportDataService.acknowledgeReport(report.indskr_coachingreportid, payload)
            .then(
              res => {
                console.log(JSON.stringify(res));
                let acknowledgedDate = new Date(payload.indskr_dateacknowledged);
                report.statecode = 1;
                report.statuscode = 548910000;
                report.indskr_dateacknowledged = acknowledgedDate.toString();
                this.selectedReport.next(report);
                let reports = this.myReportSubject.value;
                let currentReport = reports.find(data => data.indskr_coachingreportid === report.indskr_coachingreportid);
                currentReport.statuscode = 548910000;
                currentReport.statusName = "Acknowledged";
                this.events.publish('coaching-updated', report);
                this.myReportSubject.next(reports);
                this.disk.retrieve(report._id.toString()).
                  then((existingCoaching: Report) => {
                    existingCoaching.statuscode = report.statuscode;
                    existingCoaching.statusName = "Acknowledged";
                    existingCoaching.indskr_dateacknowledged = report.indskr_dateacknowledged;
                    this.disk.updateOrInsert(report._id.toString(), doc => existingCoaching);
                  });
                this.fiterReports();
                loader.dismiss();
              },
              err => {
                if(err && err.error && err.error.errorCode && err.error.errorCode=='COACHING_ALREADY_RECALLED_400'){
                  loader.dismiss();
                  report.track_action = CoachingTrackStatus.Removed;
                  this.saveToDisk(false, DB_KEY_PREFIXES.MY_COACHING, [report]);
                  let myReports: Report[] = this.myReportSubject.value;
                  myReports.forEach((item, index) =>{
                    if(item.indskr_coachingreportid === report.indskr_coachingreportid) {
                      myReports.splice(index, 1);
                    }
                  });
                  this.myReportSubject.next(myReports);
                  this.notificationService.notify(this.translate.instant('COACHING_ALREADY_RECALLED'),'','top', ToastStyle.DANGER);
                  this.navService.popToRootChildNavPageWithPageTracking();
                  this.navService.setChildNavRightPaneView(false);
                  this.fiterReports();
                  return;

                } else {
                  this.checkCoachingError(err, report);
                  loader.dismiss();
                }
              }
            );
        }
      }
    });
  }

  public async recallReport() {
    let report: Report = this.selectedReport.value;
    if ((report.statuscode !== 548910001 && report.statuscode !== 548910004) || this.activeTab !== 'teamCoaching' || this.deviceService.isOffline) return;
    let payload = { statuscode: 1, statecode: 0 };
    const loader = await this.loadingCtrl.create();
          loader.present();
          this.coachingReportDataService.recallReport(report.indskr_coachingreportid, payload)
            .then(
              res => {
                console.log(JSON.stringify(res));
                report.statecode = 0;
                report.statuscode = 1;
                this.selectedReport.next(report);
                let reports = this.teamReportSubject.value;
                let currentReport = reports.find(data => data.indskr_coachingreportid === report.indskr_coachingreportid);
                currentReport.statuscode = 1;
                currentReport.statecode = 0;
                currentReport.statusName = "Open";
                this.teamReportSubject.next(reports);
                this.disk.retrieve(report._id.toString()).
                  then((existingCoaching: Report) => {
                    existingCoaching.statuscode = report.statuscode;
                    existingCoaching.statecode = report.statecode;
                    existingCoaching.statusName = "Open";
                    this.disk.updateOrInsert(report._id.toString(), doc => existingCoaching);
                  });
                this.fiterReports();
                loader.dismiss();
              },
              err => {
                if(err && err.error && err.error.errorCode && err.error.errorCode=='COACHING_ALREADY_ACKNOWLEDGED_400'){
                  loader.dismiss();
                  this.notificationService.notify(this.translate.instant('COACHING_ALREADY_ACKNOWLEDGED'),'','top', ToastStyle.DANGER);
                  this.events.publish("open-coaching", report);
                  this.fiterReports();
                } else {
                  this.checkCoachingError(err, report);
                  loader.dismiss();
                }
              }
            );
  }

  async acceptReportOffline(payload, report: Report) {
    payload['statuscode'] = 3; // Pending Sync in Offline
    payload['indskr_accepteddate'] = new Date().getTime();
    payload["_id"] = report._id;
    let idToBeUpdated: String = payload['offlineCoachingReportId'] ? payload['offlineCoachingReportId'] : payload['indskr_coachingreportid']; //To support old records
    this.addToOfflineCoachingReportsIds(idToBeUpdated);
    report.statuscode = payload['statuscode'];
    report.statecode = payload['statecode'];
    report.indskr_accepteddate = payload['indskr_accepteddate'];
    //Create offline document
    await this.disk.createOfflineCoachingReport(report);
    await this.updateSelectedCoachingInDB(report, report);
    this.selectedReport.next(report);
    this.events.publish('coaching-updated', report);
    this.fiterReports();
  }

  async acknowledgeReportOffline(payload, report: Report) {
    payload['statuscode'] = 5; // Pending Sync in Offline
    payload["_id"] = report._id;
    let idToBeUpdated: String = payload['offlineCoachingReportId'] ? payload['offlineCoachingReportId'] : payload['indskr_coachingreportid']; //To support old records
    this.addToOfflineCoachingReportsIds(idToBeUpdated);
    report.statuscode = payload['statuscode'];
    report.statecode = payload['statecode'];
    report.indskr_dateacknowledged = payload['indskr_dateacknowledged'];
    //Create offline document
    await this.disk.createOfflineCoachingReport(payload);
    await this.updateSelectedCoachingInDB(report, report);
    this.selectedReport.next(report);
    this.events.publish('coaching-updated', report);
    this.fiterReports();
  }

  public scrapReport() {
    let report: Report = this.selectedReport.value;
    if (report.statuscode !== 1 || (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching)) return;

    this.alertService.showAlert({
      header: this.translate.instant('COACHING_SCRAP'),
      message: this.translate.instant('COACHING_R_U_SURE_WANT_SCRAP')
    }, this.translate.instant('SCRAP')
    ).then(async res => {
      if (res.role == "ok") {
        if (this.isOffline(report)) {
          await this.scrapCoachingReportOffline(report).then(() => {
            this.navService.popChildNavPageWithPageTracking();
            this.navService.setChildNavRightPaneView(false);
          });
        } else {
          const loader = await this.loadingCtrl.create();
          loader.present();
          await this.coachingReportDataService.scrapCoachingReport(report.indskr_coachingreportid)
            .then(
              res => {
                console.log(JSON.stringify(res));
                this.selectedReport.next(null);
                if (this.isSelfCoaching) {
                  this.myReportSubject.next(this.myReportSubject.value
                    .filter(data => data.indskr_coachingreportid !== report.indskr_coachingreportid));
                } else {
                  this.teamReportSubject.next(this.teamReportSubject.value
                    .filter(data => data.indskr_coachingreportid !== report.indskr_coachingreportid));
                }
                this.fiterReports();
                this.disk.remove(report._id.toString());
                loader.dismiss();
              },
              msg => {
                this.checkCoachingError(msg, report);
                loader.dismiss();
              }
            );
            this.navService.popChildNavPageWithPageTracking();
            this.navService.setChildNavRightPaneView(false);
        }
      }
    });
  }

  async scrapCoachingReportOffline(report: Report) {
    if (report.indskr_coachingreportid && report.indskr_coachingreportid.length > 0) {
      //Online create - Offline Scrap
      let payload: any = {
        'indskr_coachingreportid': report.indskr_coachingreportid,
        'offlineCoachingReportId': report.offlineCoachingReportId,
        'deleted': true
      };
      if (this.hasOfflineCoachingReportsData(report.offlineCoachingReportId ? report.offlineCoachingReportId : report.indskr_coachingreportid)) {
        await this.disk.updateofflineCoachingReportDocument(payload);
      } else {
        await this.disk.createOfflineCoachingReport(payload);
      }
      await this.disk.remove(report._id.toString()); // Remove coaching from DB
    } else {
      //Offline create - Offline remove, remove it from document
      await this.disk.removeOfflineCreatedCoachingReportFromDocument(report);
    }
    let idToBeDeleted = report.offlineCoachingReportId ? report.offlineCoachingReportId : report.indskr_coachingreportid;
    this.deleteFromOfflineCoachingReportsIds(idToBeDeleted);
    this.selectedReport.next(null);
    if (this.isSelfCoaching) {
      this.myReportSubject.next(this.myReportSubject.value
        .filter(data => data.offlineCoachingReportId ? data.offlineCoachingReportId != idToBeDeleted : data.indskr_coachingreportid !== idToBeDeleted));
    } else {
      this.teamReportSubject.next(this.teamReportSubject.value
        .filter(data => data.offlineCoachingReportId ? data.offlineCoachingReportId != idToBeDeleted : data.indskr_coachingreportid !== idToBeDeleted));
    }
    this.fiterReports();
  }

  public get isSelfCoaching(): boolean {
    return this.activeTab === 'myCoaching'
      && this.authService.hasFeatureAction(FeatureActionsMap.SELF_COACHING)
      && this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN);
  }

  private syncReportInActiveSubject(selectedReport: Report) {
    if (this.activeTab === 'myCoaching') {
      const reports = this.myReportSubject.value;
      const index = reports.findIndex(r => r.indskr_coachingreportid === selectedReport.indskr_coachingreportid);
      if (index >= 0) {
        Object.assign(reports[index], selectedReport);
        this.myReportSubject.next(reports);
      }
    } else {
      const index = this.teamReportSubject.value.findIndex(r => r.indskr_coachingreportid === selectedReport.indskr_coachingreportid);
      if (index >= 0) {
        Object.assign(this.teamReportSubject.value[index], selectedReport);
        this.teamReportSubject.next(this.teamReportSubject.value);
      }
    }
  }

  public async saveNewReport(): Promise<boolean> {
    const assessmentMatrix: AssessmentMatrix = this.assessmentMatrix.value;
    let startTime = this.dateTimeFormatsService.getStartOfDay(new Date()).valueOf();
    let endTime = this.dateTimeFormatsService.getEndOfDay(new Date()).valueOf();
    let today = new Date().getTime();
    let report = new Report("", "", "", endTime, "", startTime, "", "", "", "", 1, 0, "Open", new CoachingRating(), new CoachingRating(), "", today, "", "", "", "", "", "",null, "", `offline_coaching_report_${new Date().getTime()}`, [], [], [], [], "", "", "", "");
    let payload: any = {
      "indskr_periodstartdate": startTime.toString(),
      "indskr_periodenddate": endTime.toString(),
      "indskr_name": "For Unknown User on " + this.dateTimeFormatsService.formatDate(new Date(), "MMM DD" + ", " + "YYYY"),
      "statuscode": 1,
      "statecode": 0,
      'offlineCoachingReportId': report.offlineCoachingReportId
    };
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return false;
    const isSelf = this.isSelfCoaching;

    if (isSelf) {
      const todayStart = this.dateTimeFormatsService.getStartOfDay(new Date()).getTime();
      const hasTodayReport = this.myReportSubject.value.some(r =>
        this.dateTimeFormatsService.getStartOfDay(r.indskr_periodstartdate).getTime() === todayStart
      );
      if (hasTodayReport) {
        this.notificationService.notify(
          this.translate.instant('SELF_COACHING_DUPLICATE_DAY'),
          'Coaching Report Service',
          'top',
          ToastStyle.DANGER
        );
        return false;
      }
    }

    const loader = await this.loadingCtrl.create();
    loader.present();

    if (this.isOffline(report)) {
      this.addToOfflineCoachingReportsIds(report.offlineCoachingReportId);
      await this.disk.createOfflineCoachingReport(report);
      if (isSelf) {
        let addedReports: Report[] = [...this.myReportSubject.value, report];
        this.mapMyCoachingFieldsToSearchIndex(report);
        this.myReportSubject.next(addedReports);
      } else {
        let addedReports: Report[] = [...this.teamReportSubject.value, report];
        this.mapTeamCoachingFieldsToSearchIndex(report);
        this.teamReportSubject.next(addedReports);
      }
      this.selectedReport.next(report);
      this.fiterReports();
      loader.dismiss();
      return true;
    } else {
      let created = false;
      await this.coachingReportDataService.saveNewReport(payload)
        .then(
          async (res: Report) => {
            report.indskr_coachingreportid = res.indskr_coachingreportid;
            report.indskr_coachingrefno = res.indskr_coachingrefno ? res.indskr_coachingrefno : "";
            report.categories = res.categories;
            this.setMeasureCoachingScales(report);
            const dbPrefix = isSelf ? DB_KEY_PREFIXES.MY_COACHING : DB_KEY_PREFIXES.TEAM_COACHING;
            let _id = dbPrefix + report.indskr_coachingreportid;
            report._id = _id;

            try {
              const data = await this.disk.updateOrInsert(_id, doc => report);
              console.log("Saved new report details : " + data);
              if (isSelf) {
                let addedReports: Report[] = [...this.myReportSubject.value, report];
                this.mapMyCoachingFieldsToSearchIndex(report);
                this.myReportSubject.next(addedReports);
              } else {
                let addedReports: Report[] = [...this.teamReportSubject.value, report];
                this.mapTeamCoachingFieldsToSearchIndex(report);
                this.teamReportSubject.next(addedReports);
              }
              this.selectedReport.next(report);
              this.fiterReports();
              created = true;
            } catch (error) {
              console.error('saveNewReport: ', error);
            }
            loader.dismiss();
          },
          msg => {
            this.selectedReport.next(null);
            loader.dismiss();
          }
        );
      return created;
    }
  }

  public async updateCoachingFor(coaching: Report) {
    // if (this.selectedReport.value.indskr_coachingfor_value &&
    //   this.selectedReport.value.indskr_coachingfor_value !== coaching.indskr_coachingfor_value) {

    //   this.alertService.showAlert({
    //     title: this.translate.instant('COACHING_RESET'),
    //     message: this.translate.instant('COACHING_ALL_CHANGES_LOST_AND_RESET')}
    //   ).then (res => {
    //     if(res.role == "ok") {
    //       this.updateCoaching(coaching);
    //     }
    //   });
    // } else {
    //   this.updateCoaching(coaching);
    // }

    await this.updateCoaching(coaching);
  }

  private async updateCoaching(coaching: Report) {
    if (!this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN) && this.isDuplicateCoaching(coaching)) {
      return;
    }
    // For self-coaching, the /coachingfor API is a trainer operation (reassigns the coachingfor user
    // with position-based access) and must NOT be called for self-coaching.
    // However, indskr_coachingplan MUST be persisted to the backend even for self-coaching because
    // the team-coaching FetchXML joins coaching_report → coaching_plan → N:N associated_users to
    // determine which manager can see the record. If the plan is not on the Dynamics record, the
    // join returns NULL and the self-coaching never appears in the manager's team coaching list.
    if (this.isSelfCoaching || this.isOffline(coaching)) {
      //On change of selected user: clear meetings, ratingssummary, ratingrecommendation
      if (!coaching.indskr_coachingtemplateid) {
        coaching.meetings = [];
        coaching.phonecalls = [];
        coaching.procedureLogs = [];
        coaching.indskr_contact = "";
        coaching.indskr_contactname = "";
        coaching.indskr_account = "";
        coaching.indskr_accountname = "";
        coaching.indskr_ratingssummary = "";
        coaching.indskr_recommendations = "";
        coaching.categories = [];
      }
      coaching.min_rating = new CoachingRating();
      coaching.max_rating = new CoachingRating();
      let coachingTemplates: CoachingTemplate[];

      if (this.isSelfCoaching && coaching.indskr_coachingtemplateid) {
        // For self-coaching, the template is already set from the coaching plan selection.
        // The trainer→user template map won't have the trainee, so look up the template directly by ID.
        const template = this.coachingTemplates.find(t => t.indskr_coachingtemplateid == coaching.indskr_coachingtemplateid);
        if (template) {
          if (!template.categories || template.categories.length === 0) {
            this.retainPreviousCoachingState();
            return;
          }
          // Deep-copy so mutations to this record's measures don't bleed into
          // the shared template object used by future records.
          coaching.categories = cloneDeep(template.categories);
          this.userMappedCoachingTemplates = [template];
          // Only queue for offline upload when genuinely offline or not yet created in Dynamics.
          // For online self-coachings the offline queue would carry stale app-side
          // indskr_periodstartdate / indskr_periodenddate timestamps (set to new Date() at
          // plan-selection time) into Dynamics during delta sync. If Dynamics or a backend
          // plugin has already normalised those dates, the upload causes a spurious date change
          // that can trigger a plugin to reset assessment metrics. PouchDB is updated correctly
          // via updateSelectedCoachingInDB after the updateCoachingFor server response below.
          if (this.deviceService.isOffline || !coaching.indskr_coachingreportid) {
            await this.updateCoachingReportOffline(coaching, true);
          }
          // Call updateCoachingFor so the backend creates assessment metric shell records
          // and returns indskr_assessment_metricsid per measure. Must be awaited (with a
          // loader) so the user cannot enter ratings before the shell records exist —
          // saveOrUpdateRating requires a valid ID to update the correct Dynamics record.
          if (this.isSelfCoaching && !this.deviceService.isOffline && coaching.indskr_coachingreportid) {
            const loader = await this.loadingCtrl.create();
            loader.present();
            await this.coachingReportDataService.updateCoachingFor(coaching.indskr_coachingreportid, coaching)
              .then(async (res: Report) => {
                res.min_rating = new CoachingRating();
                res.max_rating = new CoachingRating();
                const existingCoaching = await this.updateSelectedCoachingInDB(coaching, res);
                await this.updateCoachingDetails(existingCoaching, true);
              },
              (error) => {
                this.checkCoachingError(error, coaching);
              });
            loader.dismiss();
          }
          return;
        }
        // If template not found in local cache, save as-is — categories will populate on next sync
      } else {
        let assementCategory: AssessmentCategory[] = new Array<AssessmentCategory>();
        coachingTemplates = this.getCoachingTemplatesByUser(coaching.indskr_coachingfor_value);
        if (coachingTemplates.length == 1) {
          let template = coachingTemplates[0];
          assementCategory = cloneDeep(template.categories);
          if (assementCategory.length === 0) {
            this.retainPreviousCoachingState();
            return;
          }
          coaching.categories = assementCategory;
          coaching.indskr_coachingtemplateid = template.indskr_coachingtemplateid.toString();
          coaching.indskr_coachingtemplateidname = template.indskr_name;
        }
        if (coachingTemplates.length > 1 && coaching.indskr_coachingtemplateid) {
          let template = coachingTemplates.find(temp => temp.indskr_coachingtemplateid == coaching.indskr_coachingtemplateid);
          if (template.categories.length === 0) {
            this.retainPreviousCoachingState();
            return;
          }
          coaching.categories = cloneDeep(template.categories);
        }
        this.userMappedCoachingTemplates = coachingTemplates;
      }
      if (this.deviceService.isOffline || !coaching.indskr_coachingreportid) {
        await this.updateCoachingReportOffline(coaching, true);
      }

      // Call updateCoachingFor so the backend initializes assessment metric shell records for every
      // measure in the selected template and returns indskr_assessment_metricsid per measure.
      // Must be awaited (with a loader) so the user cannot enter ratings before the shell records
      // exist — saveOrUpdateRating requires a valid ID to update the correct Dynamics record.
      if (this.isSelfCoaching && !this.deviceService.isOffline && coaching.indskr_coachingreportid) {
        const loader = await this.loadingCtrl.create();
        loader.present();
        await this.coachingReportDataService.updateCoachingFor(coaching.indskr_coachingreportid, coaching)
          .then(async (res: Report) => {
            res.min_rating = new CoachingRating();
            res.max_rating = new CoachingRating();
            const existingCoaching = await this.updateSelectedCoachingInDB(coaching, res);
            await this.updateCoachingDetails(existingCoaching, true);
          },
          (error) => {
            this.checkCoachingError(error, coaching);
          });
        loader.dismiss();
      }
      //this.navService.popWithPageTracking();
    } else {
      const loader = await this.loadingCtrl.create();
      loader.present();
      this.coachingReportDataService.updateCoachingFor(coaching.indskr_coachingreportid, coaching)
        .then(
          async (res: Report) => {
            res.min_rating = new CoachingRating();
            res.max_rating = new CoachingRating();
            let existingCoaching = await this.updateSelectedCoachingInDB(coaching, res);
            await this.updateCoachingDetails(existingCoaching, true);
            loader.dismiss();
            //this.navService.popWithPageTracking();
          },
          (error) => {
            this.checkCoachingError(error, coaching);
            loader.dismiss();
          });
    }
  }

  public isDuplicateCoaching(coaching: Report) {
    const startTime = this.dateTimeFormatsService.getStartOfDay(coaching.indskr_periodstartdate).getTime();
    const endTime = this.dateTimeFormatsService.getEndOfDay(coaching.indskr_periodenddate).getTime();
    let index = this.teamReportSubject.value.findIndex((r: Report) =>
      (r.indskr_coachingfor_value && r.indskr_coachingfor_value.length > 0) &&
      (r.indskr_coachingfor_value === coaching.indskr_coachingfor_value) &&
      (this.dateTimeFormatsService.getStartOfDay(r.indskr_periodstartdate).getTime() === startTime) &&
      (this.dateTimeFormatsService.getEndOfDay(r.indskr_periodenddate).getTime() === endTime) &&
      ((r.offlineCoachingReportId != null && r.offlineCoachingReportId !== coaching.offlineCoachingReportId) ||
        (r.indskr_coachingreportid !== coaching.indskr_coachingreportid)));
    if (index >= 0) {
      this.notificationService.notify(this.translate.instant('ERR_IO_COACHING_400'), 'Coaching Report Service', 'top', ToastStyle.DANGER);
      this.retainPreviousCoachingState();
      return true;
    }
    return false;
  }

  public isOffline(coaching: Report) {
    return this.deviceService.isOffline ||
      this.hasOfflineCoachingReportsData(coaching.offlineCoachingReportId ? coaching.offlineCoachingReportId : coaching.indskr_coachingreportid);
  }

  private async updateCoachingReportOffline(coaching: Report, refreshSelectedReport = false, payload?) {
    let idToBeUpdated: String = coaching.offlineCoachingReportId ? coaching.offlineCoachingReportId : coaching.indskr_coachingreportid; //To support old records
    if (!this.hasOfflineCoachingReportsData(idToBeUpdated)) {
      this.addToOfflineCoachingReportsIds(idToBeUpdated);
      //Create offline document
      await this.disk.createOfflineCoachingReport(payload ? payload : coaching);
    }
    else {
      //update offline upload document for this coaching
      await this.disk.updateofflineCoachingReportDocument(coaching);
    }
    //Update online created coaching in db
    let exisitingCoaching = await this.updateSelectedCoachingInDB(coaching, coaching);
    this.updateCoachingDetails(exisitingCoaching, refreshSelectedReport);
  }

  /**
   * Filters a categories array to only include entries whose category_id belongs to
   * the specified coaching template.  Used to strip residual assessment-metric records
   * from a previously-selected template that the backend failed to deactivate when the
   * trainee switched templates (OMNI-59678).  The filter uses the locally-cached
   * coachingTemplates list; if the template is not found locally, the original array is
   * returned unchanged so callers that don't have the template cached still work.
   */
  private filterCategoriesByTemplate(categories: any[], templateId: string): any[] {
    if (!templateId || !categories || categories.length === 0) return categories;
    const currentTemplate = this.coachingTemplates.find(
      t => t.indskr_coachingtemplateid === templateId
    );
    if (!currentTemplate?.categories?.length) return categories;
    const validCategoryIds = new Set<string>(
      currentTemplate.categories.map((c: any) => c.category_id)
    );
    const filtered = categories.filter((c: any) => validCategoryIds.has(c.category_id));
    // Fallback: if the filter removes everything (e.g. template cache is stale/incomplete),
    // return the unfiltered list rather than leaving the coaching with no categories.
    return filtered.length > 0 ? filtered : categories;
  }

  private async updateSelectedCoachingInDB(coaching: Report, res: Report): Promise<Report> {
    const coachingInDb = await this.disk.retrieve(coaching._id && coaching._id.length > 0 && coaching._id.toString()).
      then((existingCoaching: Report) => {
        if (existingCoaching) {
          existingCoaching.statecode = res.statecode;
          existingCoaching.statuscode = res.statuscode;
          // Guard with Array.isArray: if the server response omits these fields
          // (undefined, not an explicit empty array), keep the existing local
          // values rather than wiping activities the user can still see.
          if (Array.isArray(res.meetings)) existingCoaching.meetings = res.meetings;
          if (Array.isArray(res.phonecalls)) existingCoaching.phonecalls = res.phonecalls;
          if (Array.isArray(res.procedureLogs)) existingCoaching.procedureLogs = res.procedureLogs;
          existingCoaching.indskr_coachingfor_value = coaching.indskr_coachingfor_value;
          existingCoaching.created_for = coaching.created_for;
          existingCoaching.created_for_firstname = coaching.created_for_firstname;
          existingCoaching.indskr_name = coaching.indskr_name;
          existingCoaching.indskr_ratingssummary = res.indskr_ratingssummary;
          existingCoaching.indskr_recommendations = res.indskr_recommendations;
          if (res.categories && res.categories.length > 0) {
            const mergedCategories = res.categories.map(resCategory => {
              const localCategory = existingCoaching.categories?.find(c => c.category_id === resCategory.category_id);
              if (localCategory) {
                resCategory.measures = resCategory.measures?.map(resMeasure => {
                  const localMeasure = localCategory.measures?.find(m => m.measure_id === resMeasure.measure_id);
                  if (localMeasure) {
                    if (!resMeasure.indskr_assessment_metricsid && localMeasure.indskr_assessment_metricsid)
                      resMeasure.indskr_assessment_metricsid = localMeasure.indskr_assessment_metricsid;
                    if (!resMeasure.rating_id && localMeasure.rating_id) {
                      resMeasure.rating_id = localMeasure.rating_id;
                      resMeasure.rating_value = localMeasure.rating_value;
                      resMeasure.rating_label = localMeasure.rating_label;
                      resMeasure.rating_name = localMeasure.rating_name;
                    }
                    if (!resMeasure.score && localMeasure.score)
                      resMeasure.score = localMeasure.score;
                    if (!resMeasure.response && localMeasure.response)
                      resMeasure.response = localMeasure.response;
                    if ((resMeasure.observation == null) && localMeasure.observation != null)
                      resMeasure.observation = localMeasure.observation;
                    if ((resMeasure.overallprocedure == null) && localMeasure.overallprocedure != null)
                      resMeasure.overallprocedure = localMeasure.overallprocedure;
                    if (!resMeasure.rating_comments && localMeasure.rating_comments)
                      resMeasure.rating_comments = localMeasure.rating_comments;
                  }
                  return resMeasure;
                });
              }
              return resCategory;
            });
            // Strip categories from stale templates: when the trainee switches templates,
            // the backend may not immediately deactivate the old template's assessment metrics,
            // so the server response can include metrics from multiple templates (OMNI-59678).
            existingCoaching.categories = this.filterCategoriesByTemplate(
              mergedCategories,
              existingCoaching.indskr_coachingtemplateid || res.indskr_coachingtemplateid
            );
          }
          existingCoaching.min_rating = res.min_rating;
          existingCoaching.max_rating = res.max_rating;
          existingCoaching.indskr_periodstartdate = Number(res.indskr_periodstartdate);
          existingCoaching.indskr_periodenddate = Number(res.indskr_periodenddate);
          existingCoaching.indskr_dateacknowledged = res.indskr_dateacknowledged;
          existingCoaching.indskr_shareddate = res.indskr_shareddate;
          existingCoaching.indskr_accepteddate = res.indskr_accepteddate;
          existingCoaching.indskr_dateforreview = res.indskr_dateforreview;
          existingCoaching.indskr_coachingtemplateid = res.indskr_coachingtemplateid;
          existingCoaching.indskr_coachingplan = res.indskr_coachingplan;
          existingCoaching.indskr_coachingplanname = res.indskr_coachingplanname;
          existingCoaching.indskr_coachingtemplateidname = res.indskr_coachingtemplateidname;
          existingCoaching.indskr_coachingqualifyingscore = res.indskr_coachingqualifyingscore;
          existingCoaching.indskr_coachingscore = res.indskr_coachingscore;
          // Guard: preserve any locally stored ref no when the server response omits it
          // (e.g. the offline upload endpoint does not return this field; we should not
          // overwrite a previously fetched value with null/undefined).
          if (res.indskr_coachingrefno) {
            existingCoaching.indskr_coachingrefno = res.indskr_coachingrefno;
          }
          existingCoaching.indskr_contact = res.indskr_contact;
          existingCoaching.indskr_contactname = res.indskr_contactname;
          existingCoaching.indskr_account = res.indskr_account;
          existingCoaching.indskr_accountname = res.indskr_accountname;
          existingCoaching.indskr_overallrating = res.indskr_overallrating;
          existingCoaching.indskr_coachingtype = res.indskr_coachingtype;
          // Guard with Array.isArray: annotations are not included in the delta/list-sync
          // FetchXML payload, so res.annotations is often undefined. Unconditionally
          // assigning it would wipe all locally stored notes on every delta sync.
          if (Array.isArray(res.annotations)) existingCoaching.annotations = res.annotations;
          this.disk.updateDocWithIdAndRev(existingCoaching);
          return existingCoaching;
        }
      });
    return coachingInDb ? coachingInDb : coaching;
  }

  private updateCoachingDetails(existingCoaching: Report, refreshSelectedReport) {
    let idToBeUpdated = existingCoaching.offlineCoachingReportId ? existingCoaching.offlineCoachingReportId : existingCoaching.indskr_coachingreportid;
    existingCoaching.indskr_periodstartdate = Number(existingCoaching.indskr_periodstartdate);
    existingCoaching.indskr_periodenddate = Number(existingCoaching.indskr_periodenddate);
    this.setMeasureCoachingScales(existingCoaching);
    if (refreshSelectedReport) {
      this.selectedReport.next(existingCoaching);
    }
    // Try team reports first; if not found, check my reports (self-coaching)
    let teamIndex = this.teamReportSubject.value.findIndex((r: Report) => {
      return r.offlineCoachingReportId === idToBeUpdated || r.indskr_coachingreportid === idToBeUpdated;
    });
    if (teamIndex >= 0) {
      Object.assign(this.teamReportSubject.value[teamIndex], existingCoaching);
      this.teamReportSubject.next(this.teamReportSubject.value);
    } else {
      let myReports = this.myReportSubject.value;
      let myIndex = myReports.findIndex((r: Report) => {
        return r.offlineCoachingReportId === idToBeUpdated || r.indskr_coachingreportid === idToBeUpdated;
      });
      if (myIndex >= 0) {
        Object.assign(myReports[myIndex], existingCoaching);
        this.myReportSubject.next(myReports);
      }
    }
    this.fiterReports();
  }

  public getCoachingTemplatesByUser(coachingFor: String): CoachingTemplate[] {
    let coachingTemplates = new Array<CoachingTemplate>();
    let templatesMapped: CoachingTemplatesUser[] = this.coachingTemplatesUserMap.filter(map => map.userId == coachingFor);
    if (templatesMapped.length > 0) {
      let cochingTemplateIds: String[] = templatesMapped[0].coachingTemplateIds;
      if (cochingTemplateIds.length > 1) {
        coachingTemplates = this.coachingTemplates.filter(template => cochingTemplateIds.indexOf(template.indskr_coachingtemplateid) > -1);
      } else {
        coachingTemplates = this.coachingTemplates.filter(coachingTemplate =>
          coachingTemplate.indskr_coachingtemplateid == cochingTemplateIds[0]);
      }
    } else {
      //Show error message: No template is mapped
      this.notificationService.notify(this.translate.instant('NO_COACHING_METRICS_CONFIGURED_400'), 'Coaching Report Service', 'top', ToastStyle.DANGER);
    }
    return coachingTemplates;
  }

  async updateReport(payload: any, resetMeetings?: boolean, selectedCoachingFor?: User) {
    let selectedReport: Report = this.selectedReport.value;
    if (resetMeetings) {
      selectedReport.meetings = [];
      selectedReport.phonecalls = [];
      selectedReport.procedureLogs = [];
    }
    if (payload.hasOwnProperty("meetings")) {
      selectedReport.meetings = payload.meetings;
    }
    if (payload.hasOwnProperty("phonecalls")) {
      selectedReport.phonecalls = payload.phonecalls;
    }
    if (payload.hasOwnProperty("procedureLogs")) {
      selectedReport.procedureLogs = payload.procedureLogs;
    }
    if (payload.hasOwnProperty("indskr_periodstartdate")) {
      selectedReport.indskr_periodstartdate = parseFloat(payload.indskr_periodstartdate);
    }
    if (payload.hasOwnProperty("indskr_periodenddate")) {
      selectedReport.indskr_periodenddate = parseFloat(payload.indskr_periodenddate);
    }
    if (payload.hasOwnProperty("indskr_coachingplan")) {
      selectedReport.indskr_coachingplan = payload.indskr_coachingplan;
    }
    if (payload.hasOwnProperty("indskr_coachingtype")) {
      selectedReport.indskr_coachingtype = payload.indskr_coachingtype;
    }
    if (payload.hasOwnProperty("indskr_overallrating")) {
      selectedReport.indskr_overallrating = payload.indskr_overallrating;
    }
    if (payload.hasOwnProperty("indskr_contact")) {
      selectedReport.indskr_contact = payload.indskr_contact;
    }
    if (payload.hasOwnProperty("indskr_contactname")) {
      selectedReport.indskr_contactname = payload.indskr_contactname;
    }
    if (payload.hasOwnProperty("indskr_account")) {
      selectedReport.indskr_account = payload.indskr_account;
    }
    if (payload.hasOwnProperty("indskr_accountname")) {
      selectedReport.indskr_accountname = payload.indskr_accountname;
    }
    if (payload.hasOwnProperty("indskr_periodstartdate") || payload.hasOwnProperty("indskr_periodenddate")) {
      if (!this.authService.hasFeatureAction(FeatureActionsMap.ACCESS_COACHING_PLAN) && this.isDuplicateCoaching(selectedReport)) {
        return;
      }
    }
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;

    if (this.isOffline(selectedReport)) {
      await this.updateCoachingReportOffline(selectedReport, true);
    } else {
      const loader = await this.loadingCtrl.create();
      loader.present();
      this.coachingReportDataService.updateReport(selectedReport.indskr_coachingreportid, payload)
        .then(
          (res: any) => {
            this.disk.retrieve(selectedReport._id.toString()).
              then((existingCoaching: Report) => {
                existingCoaching.meetings = selectedReport.meetings;
                existingCoaching.phonecalls = selectedReport.phonecalls;
                existingCoaching.procedureLogs = selectedReport.procedureLogs;
                existingCoaching.indskr_periodstartdate = selectedReport.indskr_periodstartdate;
                existingCoaching.indskr_periodenddate = selectedReport.indskr_periodenddate;
                existingCoaching.indskr_coachingfor_value = selectedReport.indskr_coachingfor_value;
                existingCoaching.created_for = selectedReport.created_for;
                existingCoaching.created_for_firstname = selectedReport.created_for_firstname;
                existingCoaching.indskr_name = selectedReport.indskr_name;
                existingCoaching.categories = selectedReport.categories;
                existingCoaching.indskr_coachingplan = selectedReport.indskr_coachingplan;
                existingCoaching.indskr_coachingplanname = selectedReport.indskr_coachingplanname;
                existingCoaching.indskr_coachingtype = selectedReport.indskr_coachingtype;
                existingCoaching.indskr_overallrating = selectedReport.indskr_overallrating;
                existingCoaching.indskr_account = selectedReport.indskr_account;
                existingCoaching.indskr_accountname = selectedReport.indskr_accountname;
                existingCoaching.indskr_contact = selectedReport.indskr_contact;
                existingCoaching.indskr_contactname = selectedReport.indskr_contactname;
                existingCoaching.annotations = selectedReport.annotations;
                this.disk.updateDocWithIdAndRev(existingCoaching);
                this.updateCoachingDetails(existingCoaching, true)
              });
            loader.dismiss();
          },
          (error) => {
            this.checkCoachingError(error, selectedReport);
            loader.dismiss();
          }
        );
    }
  }

  async saveCoachingNotes(payload: any, ev?, idx?) {
    let selectedReport: Report = this.selectedReport.value;
    if (this.deviceService.isOffline){
      if(!selectedReport.annotations) selectedReport.annotations = []
      let currentNote = new IONote(payload);
      currentNote.noteId = "offline_" + new Date().getTime().toString() ;
      payload['noteId'] = "offline_" + new Date().getTime().toString() ;
      currentNote.documentDataURL = '';
      currentNote.ownerName = this.authService.user.displayName,
      currentNote.createdTime = new Date();
      selectedReport.annotations.push(currentNote);
      this.disk.updateDocWithIdAndRev(selectedReport);
      this.updateCoachingDetails(selectedReport, true)
      // this.updateCoaching(selectedReport);
      this.disk.updateOfflineCoachingNote(payload);
      return ;
    }
    {
      await this.coachingReportDataService.saveCoachingNotes([payload])
        .then(
          (obj: any) => {
            if (obj) {
              if(!selectedReport.annotations) selectedReport.annotations = [];
              for (let res of obj) {
                if (res && res['annotationid']) {
                  if (ev && idx >= 0) {
                    if (ev.action == 'DELETE' && idx >= 0) {
                      selectedReport.annotations.splice(idx, 1);
                    } else if (ev.action == 'SAVE' && idx >= 0) {
                      selectedReport.annotations[idx].noteText = ev.updatedText;
                      if (ev.attachmentFileUpdated) {
                        selectedReport.annotations[idx].hasDocument = true;
                        selectedReport.annotations[idx].documentDataURL = '';
                        selectedReport.annotations[idx].documentName = ev.documentName;
                        selectedReport.annotations[idx].documentSize = ev.documentSize;
                        selectedReport.annotations[idx].documentMimeType = ev.documentMimeType;
                      } else if (ev.isAttachmentRemoved) {
                        selectedReport.annotations[idx].hasDocument = false;
                        selectedReport.annotations[idx].documentDataURL = '';
                        selectedReport.annotations[idx].documentName = '';
                        selectedReport.annotations[idx].documentSize = 0;
                        selectedReport.annotations[idx].documentMimeType = '';
                      }
                    }
                  } else {
                    let currentNote = new IONote(payload);
                    currentNote.noteId = res['annotationid'];
                    currentNote.documentDataURL = '';
                    currentNote.ownerName = this.authService.user.displayName,
                    currentNote.createdTime = new Date();
                    selectedReport.annotations.push(currentNote);
                  }
                }
                this.disk.retrieve(selectedReport._id.toString()).
                  then((existingCoaching: Report) => {
                    existingCoaching.annotations = selectedReport.annotations;
                    this.disk.updateDocWithIdAndRev(existingCoaching);
                    this.updateCoachingDetails(existingCoaching, true)
                  });
              }
            }
          },
          (error) => {
            this.checkCoachingError(error, selectedReport);
          }
        );
    };
  }


  retainPreviousCoachingState() {
    let selectedReport: Report = this.selectedReport.value;
    this.disk.retrieve(selectedReport._id.toString()).
      then((prev_state: Report) => {
        if (prev_state) {
          let index = this.teamReportSubject.value.findIndex((r: Report) => {
            return r.indskr_coachingreportid === selectedReport.indskr_coachingreportid;
          });
          this.setMeasureCoachingScales(prev_state);
          Object.assign(this.teamReportSubject.value[index], prev_state);
          this.teamReportSubject.next(this.teamReportSubject.value);
          this.selectedReport.next(prev_state);
          this.fiterReports();
        }
      });
  }

  public async updateConfigFields(report: Report, payload: any) {
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;
    if (this.isOffline(report)) {
      payload["_id"] = report._id;
      if (payload.hasOwnProperty("indskr_coachingsessions")) {
        report['indskr_coachingsessions'] = payload.indskr_coachingsessions;
      }
      if (payload.hasOwnProperty("indskr_coachingduration")) {
        report['indskr_coachingduration'] = payload.indskr_coachingduration;
      }
      payload['indskr_coachingreportid'] = report.indskr_coachingreportid;
      if (report.offlineCoachingReportId)
        payload['offlineCoachingReportId'] = report.offlineCoachingReportId
      await this.updateCoachingReportOffline(report, false);
    } else {
      this.coachingReportDataService.updateReport(report.indskr_coachingreportid, payload)
        .then(
          (res: any) => {
            this.disk.retrieve(report._id.toString()).
            then((existingCoaching: Report) => {
              existingCoaching['indskr_coachingsessions'] = report['indskr_coachingsessions'];
              existingCoaching['indskr_coachingduration'] = report['indskr_coachingduration'];
              this.disk.updateDocWithIdAndRev(existingCoaching);
              this.updateCoachingDetails(existingCoaching, true)
            });
            console.log("Coaching config fields has been updated")
          },
          msg => {
            this.checkCoachingError(msg, report);
          }
        );
    }
  }

  public async updateRatingSummaryOrRecommendation(report: Report, payload: any) {
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;
    if (this.isOffline(report)) {
      payload["_id"] = report._id;
      if (payload.hasOwnProperty("indskr_ratingssummary")) {
        report.indskr_ratingssummary = payload.indskr_ratingssummary;
      }
      if (payload.hasOwnProperty("indskr_recommendations")) {
        report.indskr_recommendations = payload.indskr_recommendations;
      }
      payload['indskr_coachingreportid'] = report.indskr_coachingreportid;
      if (report.offlineCoachingReportId)
        payload['offlineCoachingReportId'] = report.offlineCoachingReportId
      await this.updateCoachingReportOffline(report, false);
    } else {
      this.coachingReportDataService.updateReport(report.indskr_coachingreportid, payload)
        .then(
          (res: any) => {
            this.disk.retrieve(report._id.toString()).
              then((existingCoaching: Report) => {
                existingCoaching.indskr_ratingssummary = report.indskr_ratingssummary;
                existingCoaching.indskr_recommendations = report.indskr_recommendations;
                this.disk.updateDocWithIdAndRev(existingCoaching);
              });
            console.log("Rating Summary Or Recommendation has been updated")
          },
          msg => {
            this.checkCoachingError(msg, report);
          }
        );
    }
  }

  shareReport() {
    let selectedReport: Report = this.selectedReport.value;
    let acceptCoaching = this.authService.user.acceptCoaching === 0;
    let payload: any = {
      "statuscode": 548910002,
      "indskr_shareddate": new Date().getTime()
    };
    if (acceptCoaching) {
      payload['statuscode'] = 548910003;
      payload['indskr_accepteddate'] = new Date().getTime();
    }
    if (this.activeTab !== 'teamCoaching') return;
    let alertMessage = "";
    if (!isEmpty(selectedReport.meetings) || !isEmpty(selectedReport.phonecalls))
      alertMessage = this.translate.instant('COACHING_R_U_SURE_WANT_SHARE_ACCEPTANCE');
    else
      alertMessage = this.translate.instant('COACHING_R_U_SURE_WANT_SHARE_ACCEPTANCE_WITHOUT_MEETING');

    this.alertService.showAlert({
        header: this.translate.instant('COACHING_SHARE'),
        message: alertMessage
      }, this.translate.instant('SHARE')
    ).then(async res => {
      if (res.role == "ok") {
        if (this.isOffline(selectedReport)) {
          this.shareReportOffline(selectedReport, payload, acceptCoaching);
        } else {
          const loader = await this.loadingCtrl.create();
          loader.present();
          this.coachingReportDataService.updateReport(selectedReport.indskr_coachingreportid, payload)
            .then(
              (res: Report) => {
                selectedReport.statuscode = res.statuscode;
                selectedReport.statusName = this.translate.instant("SHARED");
                let sharedDate = new Date(payload.indskr_shareddate);
                selectedReport.indskr_shareddate = sharedDate.toString();
                if (acceptCoaching) {
                  selectedReport.statusName = this.translate.instant("ACCEPTED");
                  let acceptedDate = new Date(payload.indskr_accepteddate);
                  selectedReport.indskr_accepteddate = acceptedDate.toString();
                }

                let index = this.teamReportSubject.value.findIndex((r: Report) => {
                  return r.indskr_coachingreportid === selectedReport.indskr_coachingreportid;
                });
                this.disk.retrieve(selectedReport._id.toString()).
                then((existingCoaching: Report) => {
                  existingCoaching.statuscode = selectedReport.statuscode;
                  existingCoaching.statusName = this.translate.instant("SHARED");
                  existingCoaching.indskr_shareddate = selectedReport.indskr_shareddate;
                  if (acceptCoaching) {
                    existingCoaching.statusName = this.translate.instant("ACCEPTED");
                    existingCoaching.indskr_accepteddate = selectedReport.indskr_accepteddate;
                  }
                  this.disk.updateOrInsert(selectedReport._id.toString(), doc => existingCoaching);
                });
                Object.assign(this.teamReportSubject.value[index], selectedReport);
                this.teamReportSubject.next(this.teamReportSubject.value);
                this.selectedReport.next(selectedReport);
                this.fiterReports();
              },
              msg => {
                this.checkCoachingError(msg, selectedReport);
              }
            );
          loader.dismiss();
        }
      }
    });
  }

  submitReport() {
    let selectedReport: Report = this.selectedReport.value;
    let acknowledgeCoaching = this.authService.user.acknowledgeCoaching === 0;
    let payload: any = {
      "statuscode": 548910001,
      "indskr_dateforreview": new Date().getTime()
    };
    if (acknowledgeCoaching) {
      payload['statuscode'] = 548910000;
      payload['statecode'] = 1;
      payload['indskr_dateacknowledged'] = new Date().getTime();
    }
    if ((this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) || selectedReport.statuscode === 548910001) return;
    let alertMessage = '';
    if (this.authService.hasFeatureAction(FeatureActionsMap.COACHING_SHARE)) {
      alertMessage = this.translate.instant('COACHING_R_U_SURE_WANT_SEND_ACKNOWLEDGEMENT');
    } else {
      if (!isEmpty(selectedReport.meetings) || !isEmpty(selectedReport.phonecalls))
        alertMessage = this.translate.instant('COACHING_R_U_SURE_WANT_SEND_ACKNOWLEDGEMENT');
      else
        alertMessage = this.translate.instant('COACHING_R_U_SURE_WANT_SEND_ACKNOWLEDGEMENT_WITHOUT_ACTIVITIES');
    }

    this.alertService.showAlert({
      header: this.translate.instant('COACHING_SEND'),
      message: alertMessage
    }, this.translate.instant('SEND')
    ).then(async res => {
      if (res.role == "ok") {
        if (this.isOffline(selectedReport)) {
          this.submitReportOffline(selectedReport, payload, acknowledgeCoaching);
        } else {
          const loader = await this.loadingCtrl.create();
          loader.present();
          this.coachingReportDataService.updateReport(selectedReport.indskr_coachingreportid, payload)
            .then(
              (res: Report) => {
                selectedReport.statuscode = res.statuscode;
                let sendDate = new Date(payload.indskr_dateforreview);
                selectedReport.indskr_dateforreview = sendDate.toString();
                if (acknowledgeCoaching) {
                  let ackDate = new Date(payload.indskr_dateacknowledged);
                  selectedReport.indskr_dateacknowledged = ackDate.toString();
                  selectedReport.statecode = 1;
                  selectedReport.statusName = "Acknowledged";
                }
                this.disk.retrieve(selectedReport._id.toString()).
                  then((existingCoaching: Report) => {
                    existingCoaching.statuscode = selectedReport.statuscode;
                    existingCoaching.indskr_dateforreview = selectedReport.indskr_dateforreview;
                    if (acknowledgeCoaching) {
                      existingCoaching.indskr_dateacknowledged = selectedReport.indskr_dateacknowledged;
                      existingCoaching.statecode = selectedReport.statecode;
                      existingCoaching.statusName = selectedReport.statusName;
                    }
                    this.disk.updateOrInsert(selectedReport._id.toString(), doc => existingCoaching);
                  });
                this.syncReportInActiveSubject(selectedReport);
                this.selectedReport.next(selectedReport);
                this.fiterReports();
              },
              msg => {
                this.checkCoachingError(msg, selectedReport);
              }
            );
          loader.dismiss();
        }
      }
    });
  }

  closeReport() {
    let selectedReport: Report = this.selectedReport.value;
    let payload: any = {
      "statuscode": 548910004
    };
    if ((this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) || selectedReport.statuscode === 548910001) return;
    let alertMessage = this.translate.instant('COACHING_R_U_SURE_WANT_CLOSE_COACHING');

    this.alertService.showAlert({
      header: this.translate.instant('COACHING_CLOSE'),
      message: alertMessage
    }, this.translate.instant('COMPLETE')
    ).then(async res => {
      if (res.role == "ok") {
        if (this.deviceService.isOffline || !selectedReport.indskr_coachingreportid) {
          selectedReport.statuscode = 548910004;
          selectedReport.indskr_dateforreview = new Date().getTime();
          await this.updateCoachingReportOffline(selectedReport, true);
        } else {
          const loader = await this.loadingCtrl.create();
          loader.present();
          this.coachingReportDataService.updateReport(selectedReport.indskr_coachingreportid, payload)
            .then(
              (res: Report) => {
                selectedReport.statuscode = res.statuscode;
                this.disk.retrieve(selectedReport._id.toString()).
                  then((existingCoaching: Report) => {
                    existingCoaching.statuscode = selectedReport.statuscode;
                    existingCoaching.indskr_dateforreview = selectedReport.indskr_dateforreview;
                    this.disk.updateOrInsert(selectedReport._id.toString(), doc => existingCoaching);
                  });
                this.syncReportInActiveSubject(selectedReport);
                this.selectedReport.next(selectedReport);
                this.fiterReports();
              },
              msg => {
                this.checkCoachingError(msg, selectedReport);
              }
            );
          loader.dismiss();
        }
      }
    });
  }

  private async submitReportOffline(report: Report, payload, acknowledgeCoaching?: boolean) {
    report.statuscode = 4; // Pending Sync in Offline
    report.indskr_dateforreview = new Date().getTime();
    if (acknowledgeCoaching) {
      report.statuscode = 5;
      report.statecode = 1;
      report.indskr_dateacknowledged = new Date().getTime();
      payload['indskr_dateacknowledged'] = report.indskr_dateacknowledged;
      payload['statecode'] = report.statecode;
    }
    payload["_id"] = report._id;
    payload['indskr_coachingreportid'] = report.indskr_coachingreportid;
    if (report.offlineCoachingReportId)
      payload['offlineCoachingReportId'] = report.offlineCoachingReportId
    payload['statuscode'] = report.statuscode;
    payload['indskr_dateforreview'] = report.indskr_dateforreview;
    await this.updateCoachingReportOffline(report, true);
  }

  private async shareReportOffline(report: Report, payload, acceptCoaching?: boolean) {
    report.statuscode = 2; // Pending Sync in Offline
    report.indskr_shareddate = new Date().getTime();
    if (acceptCoaching) {
      report.statuscode = 3
      report.indskr_accepteddate = new Date().getTime();
      payload['indskr_accepteddate'] = report.indskr_accepteddate;
    }
    payload["_id"] = report._id;
    payload['indskr_coachingreportid'] = report.indskr_coachingreportid;
    if (report.offlineCoachingReportId)
      payload['offlineCoachingReportId'] = report.offlineCoachingReportId
    payload['indskr_shareddate'] = report.indskr_shareddate;
    payload['statuscode'] = report.statuscode;
    await this.updateCoachingReportOffline(report, true);
  }

  static processAssessmentCategories(categories: AssessmentCategory[]): AssessmentCategory[] {
    for (let i = 0; i < categories.length; i++) {
      //For each category, filter the "measure" array to not include empty ratings
      categories[i].measures = categories[i].measures.filter((m) => {
        return ((m.rating_id != undefined
          && m.rating_id != "") || m.rating_id != null)
      });
    }
    return categories.filter((c) => c.measures.length != 0);
  }

  public isMaxRating(rating: number, ratingscale_id: String): boolean {
    //Considering only one assessment scale for all the measures, get the scale from first measure of the category
    if (ratingscale_id) {
      const ratings: AssessmentRating[] = this.coachingScales.get(ratingscale_id);
      if (ratings) {
        let max: number = Math.max(...ratings.map(value => value.rating_value));
        if (max % 2 == 0) {
          return rating > max / 2;
        }
        return rating >= max / 2;
      }
    }
    return false;
  }


  public async openActivityDetails(activity_id: string) {
    this.activityDataService.activityDetailsLoaded = false;
    this.uiService.showRightPane = true;
    this.activityClick = true;
    await this.activityDataService.getActivityByIdOnline(activity_id, "appointment")
      .then(async response => {
        let activity: Activity = new AppointmentActivity(response);
        this.setActivityCoaching(activity);
        this.uiService.activeView = 'Appointment';
        this.activityService.selectedActivity = activity;
        await this.activityDataService._appendMeetingDetailsToActivity(activity, response, false);
        this.activityDataService.activityDetailsLoaded = true;
      })
  }

  public async openPhoneCallActivityDetails(activity: CoachingActivity) {
    this.activityDataService.activityDetailsLoaded = false;
    this.uiService.showRightPane = true;
    this.activityClick = true;
    await this.activityDataService.getPhonecallActivityByIdOnline(activity.indskr_activityid, activity.indskr_scheduledstart.toString(), activity.indskr_scheduledend.toString(), this.selectedReport.value.indskr_periodstartdate.toString())
      .then(async response => {
        let activity: PhoneActivity = new PhoneActivity(response);
        this.setActivityCoaching(activity);
        this.uiService.activeView = 'PhoneCall';
        this.activityService.selectedActivity = activity;
        await this.activityDataService._appendPhoneCallDetailsToActivity(activity, response, false);
        this.activityDataService.activityDetailsLoaded = true;
      });
      setTimeout(() => {
        this.events.publish('detectChangesOnPhoneCallActivityDetails');
      }, 100);
  }


  // public findCoachingReportsByActivityId(activity_id: string):Report[] {

  // }

  private async persistMeasureUpdate(
    selectedReport: Report,
    categoryId: String,
    measureId: String,
    payload: any,
    offlineUpdateFn: (measure: AssessmentMeasure) => void,
    onlineUpdateFn: (measure: AssessmentMeasure, res: AssessmentMeasure) => void,
    syncScoreFields: boolean = true
  ): Promise<void> {
    if (this.isOffline(selectedReport)) {
      selectedReport.categories.find(data => data.category_id === categoryId).measures.forEach(measure => {
        if (measure.measure_id === measureId) {
          offlineUpdateFn(measure);
        }
      });
      await this.updateCoachingReportOffline(selectedReport);
    } else {
      await this.coachingReportDataService.saveOrUpdateRating(selectedReport.indskr_coachingreportid.toString(), categoryId.toString(), payload)
        .then(
          (res: AssessmentMeasure) => {
            selectedReport.categories.find(data => data.category_id === categoryId).measures.forEach(measure => {
              if (measure.measure_id === measureId) {
                onlineUpdateFn(measure, res);
              }
            });
            let index = this.teamReportSubject.value.findIndex((r: Report) => {
              return r.indskr_coachingreportid === selectedReport.indskr_coachingreportid;
            });
            Object.assign(this.teamReportSubject.value[index], selectedReport);
            this.teamReportSubject.next(this.teamReportSubject.value);
            this.disk.retrieve(selectedReport._id.toString()).then((existingCoaching: Report) => {
              existingCoaching.categories = selectedReport.categories;
              if (syncScoreFields) {
                existingCoaching.min_rating = selectedReport.min_rating;
                existingCoaching.max_rating = selectedReport.max_rating;
                existingCoaching.indskr_coachingqualifyingscore = selectedReport.indskr_coachingqualifyingscore;
                existingCoaching.indskr_coachingscore = selectedReport.indskr_coachingscore;
              }
              this.disk.updateDocWithIdAndRev(existingCoaching);
            });
            this.fiterReports();
          },
          msg => {
            this.checkCoachingError(msg, selectedReport);
          }
        );
    }
  }

  public async saveOrUpdateRating(value: number, rating_label: String, rating_id: String, category_id: String, measure_id: String) {
    const selectedReport: Report = this.selectedReport.value;
    let measure: AssessmentMeasure = selectedReport.categories.find(data => data.category_id === category_id).measures.find((measure) => measure.measure_id === measure_id);
    measure.rating_id = rating_id;
    measure.rating_value = value;
    measure.rating_label = rating_label
    measure.clearRating = false;
    this.applyMinAndMaxRatings(selectedReport);
    let payload: any = {
      "indskr_assessment_metricsid": measure.indskr_assessment_metricsid ? measure.indskr_assessment_metricsid : "",
      "measure_id": measure_id,
      "rating_id": rating_id
    };
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;
    await this.calculateCoachingScore();
    payload['indskr_coachingqualifyingscore'] = selectedReport.indskr_coachingqualifyingscore;
    payload['indskr_coachingscore'] = selectedReport.indskr_coachingscore;
    payload['indskr_coachingreportid'] = selectedReport.indskr_coachingreportid;
    await this.persistMeasureUpdate(
      selectedReport, category_id, measure_id, payload,
      (m) => { m.rating_id = rating_id; m.rating_value = value; m.rating_label = rating_label; },
      (m, res) => { m.rating_id = rating_id; m.rating_value = value; m.rating_label = rating_label; m.indskr_assessment_metricsid = res.indskr_assessment_metricsid; }
    );
  }

  async calculateCoachingScore() {
    this.givenRatingsWeight = 0;
    this.templateWeight = 0;
    let report: Report = this.selectedReport.getValue();
    report.categories.forEach(cat => {
      cat.measures.filter(o=>o.measure_isrequired).forEach(m => {
        let givenValue;
        let maxValue;
        if (m.ratingscale_id) {
          givenValue = m.rating_value ? m.rating_value : 0;
          maxValue = Math.max(...m.ratings.map(r=> r.rating_value));
        } else {
          givenValue = m.score ? Number(m.score) : 0;
          maxValue = m.max_rating;
        }
        this.givenRatingsWeight += givenValue;
        this.templateWeight += maxValue;
      })
      //adding the non-mandatory measure into claculation if their is a value provided
      cat.measures.filter(o=>!o.measure_isrequired && (o.rating_value || o.score)).forEach(m=> {
        let givenValue;
        let maxValue;
        if (m.ratingscale_id && m.rating_value) {
          givenValue = m.rating_value;
          maxValue = Math.max(...m.ratings.map(r=> r.rating_value));
        } else if(m.score) {
          givenValue = Number(m.score);
          maxValue = m.max_rating;
        }
        this.givenRatingsWeight += givenValue;
        this.templateWeight += maxValue;
      })
    })
    report.indskr_coachingqualifyingscore = this.authService.user.coachingQualifyingScore;
    let coachingScore = String(((this.givenRatingsWeight/this.templateWeight)*100).toFixed(2));
    report.indskr_coachingscore = coachingScore === '0' || coachingScore === 'NaN' || coachingScore === null ? '' : coachingScore;
  }

  public async saveOrUpdateFreeTextResponse(response: String, category_id: String, measure_id: String) {
    const selectedReport: Report = this.selectedReport.value;
    let measure: AssessmentMeasure = selectedReport.categories.find(data => data.category_id === category_id).measures.find((measure) => measure.measure_id === measure_id);
    measure.response = response;
    measure.clearRating = false;
    let payload: any = {
      "indskr_assessment_metricsid": measure.indskr_assessment_metricsid ? measure.indskr_assessment_metricsid : "",
      "measure_id": measure_id,
      "response": response ? response : ""
    };
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;
    payload['indskr_coachingreportid'] = selectedReport.indskr_coachingreportid;
    if (this.isOffline(selectedReport)) {
      selectedReport.categories.find(data => data.category_id === category_id).measures.forEach(measure => {
        if (measure.measure_id === measure_id) {
          measure.response = response;
          measure.indskr_assessment_metricsid = measure.indskr_assessment_metricsid;
        }
      });
      await this.updateCoachingReportOffline(selectedReport);
    } else {
      await this.coachingReportDataService.saveOrUpdateRating(selectedReport.indskr_coachingreportid.toString(), category_id.toString(), payload)
        .then(
          (res: AssessmentMeasure) => {
            selectedReport.categories.find(data => data.category_id === category_id).measures.forEach(measure => {
              if (measure.measure_id === measure_id) {
                measure.response = response;
                measure.indskr_assessment_metricsid = res.indskr_assessment_metricsid;
              }
            });
            this.syncReportInActiveSubject(selectedReport);
            this.disk.retrieve(selectedReport._id.toString()).
            then((existingCoaching: Report) => {
              existingCoaching.categories = selectedReport.categories;
              this.disk.updateDocWithIdAndRev(existingCoaching);
            });
            this.fiterReports();
          },
          msg => {
            this.checkCoachingError(msg, selectedReport);
          }
        );
    }
  }

  public async saveOrUpdateRatingScore(score: String, category_id: String, measure_id: String) {
    const selectedReport: Report = this.selectedReport.value;
    let measure: AssessmentMeasure = selectedReport.categories.find(data => data.category_id === category_id).measures.find((measure) => measure.measure_id === measure_id);
    measure.score = score;
    measure.clearRating = false;
    this.applyMinAndMaxRatings(selectedReport);
    let payload: any = {
      "indskr_assessment_metricsid": measure.indskr_assessment_metricsid ? measure.indskr_assessment_metricsid : "",
      "measure_id": measure_id,
      "score": score ? score : ""
    };
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;
    await this.calculateCoachingScore();
    payload['indskr_coachingqualifyingscore'] = selectedReport.indskr_coachingqualifyingscore;
    payload['indskr_coachingscore'] = selectedReport.indskr_coachingscore;
    payload['indskr_coachingreportid'] = selectedReport.indskr_coachingreportid;
    await this.persistMeasureUpdate(
      selectedReport, category_id, measure_id, payload,
      (m) => { m.score = score; },
      (m, res) => { m.score = score; m.indskr_assessment_metricsid = res.indskr_assessment_metricsid; }
    );
  }

  public async saveOrUpdateObservation(obs: number, category_id: String, measure_id: String) {
    const selectedReport: Report = this.selectedReport.value;
    let measure: AssessmentMeasure = selectedReport.categories.find(data => data.category_id === category_id).measures.find((measure) => measure.measure_id === measure_id);
    measure.observation = obs;
    measure.clearRating = false;
    let payload: any = {
      "indskr_assessment_metricsid": measure.indskr_assessment_metricsid ? measure.indskr_assessment_metricsid : "",
      "measure_id": measure_id,
      "observation": obs ? obs : null
    };
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;
    payload['indskr_coachingreportid'] = selectedReport.indskr_coachingreportid;
    await this.persistMeasureUpdate(
      selectedReport, category_id, measure_id, payload,
      (m) => { m.observation = obs; },
      (m, res) => { m.observation = obs; m.indskr_assessment_metricsid = res.indskr_assessment_metricsid; }
    );
  }

  public async saveOrUpdateOverallProcedure(op: boolean, category_id: String, measure_id: String) {
    const selectedReport: Report = this.selectedReport.value;
    let measure: AssessmentMeasure = selectedReport.categories.find(data => data.category_id === category_id).measures.find((measure) => measure.measure_id === measure_id);
    measure.overallprocedure = op;
    measure.clearRating = false;
    let payload: any = {
      "indskr_assessment_metricsid": measure.indskr_assessment_metricsid ? measure.indskr_assessment_metricsid : "",
      "measure_id": measure_id,
      "overallprocedure": op
    };
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;
    payload['indskr_coachingreportid'] = selectedReport.indskr_coachingreportid;
    await this.persistMeasureUpdate(
      selectedReport, category_id, measure_id, payload,
      (m) => { m.overallprocedure = op; },
      (m, res) => { m.overallprocedure = op; m.indskr_assessment_metricsid = res.indskr_assessment_metricsid; }
    );
  }

  public async saveOrUpdateRatingComments(ratingComment, category_id: string, m: AssessmentMeasure) {
    const selectedReport: Report = this.selectedReport.value;
    let measure: AssessmentMeasure = selectedReport.categories.find(data => data.category_id === category_id).measures.find((measure) => measure.measure_id === m.measure_id);
    let payload: any = {
      "indskr_assessment_metricsid": measure.indskr_assessment_metricsid ? measure.indskr_assessment_metricsid : "",
      "rating_comments": ratingComment
    };
    if (this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) return;
    await this.persistMeasureUpdate(
      selectedReport, category_id, m.measure_id, payload,
      (ms) => { ms.rating_comments = ratingComment; },
      (ms, res) => { ms.rating_comments = res.rating_comments; ms.indskr_assessment_metricsid = res.indskr_assessment_metricsid; },
      false
    );
  }

  async clearRatings(category_id: String) {
    let selectedReport: Report = this.selectedReport.value;
    const payload: AssessmentMeasure[] = selectedReport.categories.find(data => data.category_id === category_id).measures.filter(ms => ms.ratingscale_id ? (ms.rating_id && !ms.clearRating) : ((ms.score || ms.response) && !ms.clearRating));
    if ((this.activeTab !== 'teamCoaching' && !this.isSelfCoaching) || !payload.length) return;
    this.alertService.showAlert({
      header: this.translate.instant('COACHING_CLEAR_RATINGS'),
      message: this.translate.instant('COACHING_PLEASE_NOTE')
    }, this.translate.instant('CLEAR')
    ).then(async res => {
      if (res.role == "ok") {
        if (this.isOffline(selectedReport)) {
          await this.updateClearRatingDetails(selectedReport, category_id, true);
          await this.calculateCoachingScore();
          await this.updateCoachingReportOffline(selectedReport, true);
        } else {
          const loader = await this.loadingCtrl.create();
          loader.present();
          await this.coachingReportDataService.clearRatings(selectedReport.indskr_coachingreportid.toString(), payload)
            .then(
              async () => {

                await this.updateClearRatingDetails(selectedReport, category_id);
                await this.calculateCoachingScore();
                this.syncReportInActiveSubject(selectedReport);

                let scorePayload = {
                  indskr_coachingqualifyingscore: selectedReport.indskr_coachingqualifyingscore,
                  indskr_coachingscore: selectedReport.indskr_coachingscore
                };
                await this.coachingReportDataService.updateScore(selectedReport.indskr_coachingreportid.toString(), scorePayload).then(() => {

                    this.disk.retrieve(selectedReport._id.toString()).then((existingCoaching: Report) => {
                      existingCoaching.categories = selectedReport.categories;
                      existingCoaching.min_rating = selectedReport.min_rating;
                      existingCoaching.max_rating = selectedReport.max_rating;
                      existingCoaching.indskr_coachingqualifyingscore = selectedReport.indskr_coachingqualifyingscore;
                      existingCoaching.indskr_coachingscore = selectedReport.indskr_coachingscore;
                      this.disk.updateDocWithIdAndRev(existingCoaching);
                    });
                    this.fiterReports();
                    this.selectedReport.next(selectedReport);
                    loader.dismiss();
                });
            },
            async msg => {
              await this.checkCoachingError(msg, selectedReport);
              await loader.dismiss();
            });
        }
      }
    });
  }

  private async updateClearRatingDetails(selectedReport: Report, category_id: String, isOffline: boolean = false) {
    selectedReport.categories.find(data => data.category_id === category_id).measures.forEach((measure) => {
      // if (!isOffline)
        measure.rating_id = null;
      measure.rating_label = null;
      measure.rating_value = 0;
      measure.rating_name = null;
      measure.score = "";
      measure.response = "";
      measure.rating_comments = null;
      measure.clearRating = true
    });
    this.applyMinAndMaxRatings(selectedReport);
  }

  private applyMinAndMaxRatings(report: Report) {
    let ratings: number[] = [];
    let ratingscale_id: String = null;
    report.categories.forEach(category => {
      category.measures.forEach(measure => {
        if (measure.rating_id && ratings.indexOf(measure.rating_value) == -1 && !measure.clearRating) {
          ratings.push(measure.rating_value);
          if (!ratingscale_id) ratingscale_id = measure.ratingscale_id;
        }
      });
    });
    if (ratings.length > 0) {
      if (ratings.length == 1) {
        let max: boolean = this.isMaxRating(ratings[0], ratingscale_id);
        if (max) {
          report.max_rating = new CoachingRating(ratings[0], true);
          report.min_rating = new CoachingRating();
        } else {
          report.max_rating = new CoachingRating();
          report.min_rating = new CoachingRating(ratings[0], true);
        }
      } else {
        report.max_rating = new CoachingRating(Math.max(...ratings), true);
        report.min_rating = new CoachingRating(Math.min(...ratings), true);
      }
    } else {
      report.min_rating = new CoachingRating();
      report.max_rating = new CoachingRating();
    }
  }

  public async checkCoachingOnline(report: Report) {
    await this.uiService.displayLoader();
    await this.coachingReportDataService.getCoachingById(report.indskr_coachingreportid, this.activeTab, report.statuscode)
      .then(
        async (response: Report) => {
          // A blank or null response (e.g. server returns 200 with empty body) must be
          // treated as a no-op: fall through to selectedReport.next(report) so the UI
          // shows the locally-cached coaching rather than crashing or wiping data.
          if (!response) {
            this.selectedReport.next(report);
            await this.uiService.dismissLoader();
            return;
          }
          if(response.hasOwnProperty('indskr_coachingplanname')) report.indskr_coachingplanname = response.indskr_coachingplanname ;
          if (response.hasOwnProperty('statuscode') && response.statuscode !== report.statuscode) {
            if (this.activeTab === 'myCoaching') {
              if(response.statuscode == 1) {
                response.track_action = CoachingTrackStatus.Removed;
                await this.saveToDisk(false, DB_KEY_PREFIXES.MY_COACHING, [response]);
                let myReports: Report[] = this.myReportSubject.value;
                myReports.forEach((item, index) =>{
                  if(item.indskr_coachingreportid === report.indskr_coachingreportid) {
                    myReports.splice(index, 1);
                  }
                });
                this.myReportSubject.next(myReports);
                if(report.statuscode == 548910001) {
                  this.notificationService.notify(this.translate.instant('COACHING_ALREADY_RECALLED'),'','top', ToastStyle.DANGER);
                }
                report.statuscode = response.statuscode;
                // this.navService.popToRootChildNavPageWithPageTracking();
              } else {
                report.statuscode = response.statuscode;
                report.indskr_dateacknowledged = response.indskr_dateacknowledged;
                report.indskr_shareddate = response.indskr_shareddate;
                report.indskr_accepteddate = response.indskr_accepteddate;
                report.indskr_dateforreview = response.indskr_dateforreview;
                report.indskr_coachingduration = response.indskr_coachingduration;
                report.indskr_coachingsessions = response.indskr_coachingsessions;
                const updatedReport =  await this.updateSelectedCoachingInDB(report, response);
                let myReports: Report[] = this.myReportSubject.value;
                const idx = myReports.findIndex(r => r.indskr_coachingreportid === report.indskr_coachingreportid);
                if (idx >= 0) {
                  this.setMeasureCoachingScales(updatedReport);
                  myReports[idx]= updatedReport;
                  this.myReportSubject.next(myReports);
                  this.selectedReport.next(updatedReport);
                }
              }

            } else {
              report.statuscode = response.statuscode;
              report.indskr_dateacknowledged = response.indskr_dateacknowledged;
              report.indskr_shareddate = response.indskr_shareddate;
              report.indskr_accepteddate = response.indskr_accepteddate;
              report.indskr_dateforreview = response.indskr_dateforreview;
              report.indskr_coachingduration = response.indskr_coachingduration;
              report.indskr_coachingsessions = response.indskr_coachingsessions;
              // Guard with .length > 0: an empty array is truthy in JS and would wipe
              // the locally stored template measure definitions if not checked.
              if (response.categories && response.categories.length > 0) {
                report.categories = this.filterCategoriesByTemplate(
                  response.categories, report.indskr_coachingtemplateid
                );
                this.setMeasureCoachingScales(report);
              }
              this.disk.retrieve(report._id.toString()).
                then(async (existingCoaching: Report) => {
                  if (existingCoaching) {
                    existingCoaching.statuscode = report.statuscode;
                    existingCoaching.indskr_dateacknowledged = report.indskr_dateacknowledged;
                    existingCoaching.indskr_shareddate = report.indskr_shareddate;
                    existingCoaching.indskr_accepteddate = report.indskr_accepteddate;
                    existingCoaching.indskr_dateforreview = report.indskr_dateforreview;
                    existingCoaching.indskr_coachingduration = report.indskr_coachingduration;
                    existingCoaching.indskr_coachingsessions = report.indskr_coachingsessions;
                    // Persist captured category values (rating_id, score, etc.) so the trainer
                    // does not need a fresh server fetch on every app restart to see them.
                    if (response.categories && response.categories.length > 0) {
                      existingCoaching.categories = report.categories;
                    }
                    await this.disk.updateDocWithIdAndRev(existingCoaching);
                  }
                });
                this.teamReportSubject.next(this.teamReportSubject.value);
                this.selectedReport.next(report);
            }
            this.fiterReports();
          } else {
            // Guard: only overwrite annotations when the response actually includes them.
            // An empty/blank response would set annotations to undefined, wiping all notes.
            if (Array.isArray(response.annotations)) {
              report.annotations = response.annotations;
            }
            // Sync scalar metadata that can change on the server even when statuscode is unchanged.
            // indskr_coachingrefno is assigned by a Dynamics plugin after record creation and is NOT
            // present in the offline upload response — the first time the coaching becomes "online"
            // (i.e. when the user taps it after the offline push) the only way to get it is from this
            // getCoachingById call. Without this copy the details view shows "No Coaching Ref No"
            // until the next full delta sync overwrites the value via updateSelectedCoachingInDB.
            if (response.indskr_coachingrefno) {
              report.indskr_coachingrefno = response.indskr_coachingrefno;
            }
            if (response.indskr_coachingduration != null) {
              report.indskr_coachingduration = response.indskr_coachingduration;
            }
            if (response.indskr_coachingsessions != null) {
              report.indskr_coachingsessions = response.indskr_coachingsessions;
            }
            // After "Refresh Data", disk.resetDb() wipes PouchDB and the subsequent initial
            // sync uses GET_MY_COACHING_REPORTS which may not return indskr_coachingfor_value
            // or created_for for self-coaching records. The per-record getCoachingById endpoint
            // reliably returns them, so copy here so "Coaching By" is never blank after refresh.
            if (response.indskr_coachingfor_value) {
              report.indskr_coachingfor_value = response.indskr_coachingfor_value;
            }
            if (response.created_for) {
              report.created_for = response.created_for;
            }
            if (response.created_for_firstname) {
              report.created_for_firstname = response.created_for_firstname;
            }
            // Self-coaching fallback: GET_MY_COACHING_REPORT may not include
            // indskr_coachingfor_value / created_for for self-coaching records (those
            // fields are implied by the current user context on the server). After
            // Refresh Data the list-sync record has them blank. If they are still blank
            // after copying from the server response above, populate from auth user so
            // the "Coaching By" field is never blank for the trainee's own coaching.
            if (this.isSelfCoaching && !report.indskr_coachingfor_value) {
              report.indskr_coachingfor_value = this.authService.user.systemUserID;
              report.created_for = this.authService.user.displayName;
            }
            // Sync trainer-updatable header fields so the trainee immediately sees
            // Coaching Type, Overall Rating, Contact, Account, and Activity changes
            // made by the trainer on an open self-coaching without waiting for the
            // next full delta sync.
            if (response.indskr_overallrating != null) {
              report.indskr_overallrating = response.indskr_overallrating;
            }
            if (response.indskr_coachingtype != null) {
              report.indskr_coachingtype = response.indskr_coachingtype;
            }
            if (response.indskr_contact !== undefined) {
              report.indskr_contact = response.indskr_contact;
              report.indskr_contactname = response.indskr_contactname;
            }
            if (response.indskr_account !== undefined) {
              report.indskr_account = response.indskr_account;
              report.indskr_accountname = response.indskr_accountname;
            }
            if (response.indskr_ratingssummary !== undefined) {
              report.indskr_ratingssummary = response.indskr_ratingssummary;
            }
            if (response.indskr_recommendations !== undefined) {
              report.indskr_recommendations = response.indskr_recommendations;
            }
            if (Array.isArray(response.meetings)) report.meetings = response.meetings;
            if (Array.isArray(response.phonecalls)) report.phonecalls = response.phonecalls;
            if (Array.isArray(response.procedureLogs)) report.procedureLogs = response.procedureLogs;
            // Sync categories whenever statuscode is unchanged and the response contains category data.
            // - teamCoaching (statuscode=1): trainer needs to see metric values captured by the trainee.
            // - myCoaching self-coaching (statuscode=1): trainee needs to see metric values captured by the trainer.
            // The list-sync FetchXML only includes template measure definitions, not the
            // indskr_assessment_metrics records that hold actual rating/score/response values.
            const shouldSyncCategories = (this.activeTab === 'teamCoaching' || this.isSelfCoaching)
              && response.categories && response.categories.length > 0;

            // Retrieve PouchDB BEFORE the merge so we can use the stored indskr_assessment_metricsid
            // values as the authoritative local source. The report object coming in here was populated
            // from the list-sync FetchXML which never includes assessment metric IDs. Using report.categories
            // alone as the local fallback would lose the IDs that were persisted to PouchDB during the
            // initial updateCoachingFor call, causing saveOrUpdateRating to send empty IDs to the backend
            // and silently fail or create orphaned Dynamics records.
            const existingCoachingFromDb: Report = await this.disk.retrieve(
              report._id && report._id.length > 0 && report._id.toString()
            );

            if (shouldSyncCategories) {
              // For each measure, prefer server-captured values when present. If a field is
              // absent in the server response (e.g. the endpoint omits metric IDs or captured
              // values), carry the local value forward — preferring PouchDB over the list-sync
              // report, since PouchDB holds the real indskr_assessment_metricsid set by
              // updateCoachingFor initialization and any previously captured rating/score values.
              response.categories.forEach(resCategory => {
                // Prefer PouchDB categories as the local source; fall back to list-sync
                const localCategory =
                  existingCoachingFromDb?.categories?.find(c => c.category_id === resCategory.category_id)
                  || report.categories?.find(c => c.category_id === resCategory.category_id);
                if (localCategory) {
                  resCategory.measures?.forEach(resMeasure => {
                    const localMeasure = localCategory.measures?.find(m => m.measure_id === resMeasure.measure_id);
                    if (localMeasure) {
                      if (!resMeasure.indskr_assessment_metricsid && localMeasure.indskr_assessment_metricsid) {
                        resMeasure.indskr_assessment_metricsid = localMeasure.indskr_assessment_metricsid;
                      }
                      if (!resMeasure.rating_id && localMeasure.rating_id) {
                        resMeasure.rating_id = localMeasure.rating_id;
                        resMeasure.rating_value = localMeasure.rating_value;
                        resMeasure.rating_label = localMeasure.rating_label;
                        resMeasure.rating_name = localMeasure.rating_name;
                      }
                      if (!resMeasure.score && localMeasure.score) {
                        resMeasure.score = localMeasure.score;
                      }
                      if (!resMeasure.response && localMeasure.response) {
                        resMeasure.response = localMeasure.response;
                      }
                      if (!resMeasure.observation && localMeasure.observation) {
                        resMeasure.observation = localMeasure.observation;
                      }
                      if (!resMeasure.overallprocedure && localMeasure.overallprocedure) {
                        resMeasure.overallprocedure = localMeasure.overallprocedure;
                      }
                      if (!resMeasure.rating_comments && localMeasure.rating_comments) {
                        resMeasure.rating_comments = localMeasure.rating_comments;
                      }
                    }
                  });
                }
              });
              // Strip categories that belong to a previously-selected template.
              // The getCoachingById endpoint joins ALL active assessment_metrics records —
              // if the backend did not deactivate old template records when the trainee
              // changed templates, both templates' categories appear in the response.
              // filterCategoriesByTemplate uses the locally-cached template definition to
              // keep only the categories that are part of the coaching's current template
              // (report.indskr_coachingtemplateid), removing stale residual categories.
              report.categories = this.filterCategoriesByTemplate(
                response.categories, report.indskr_coachingtemplateid
              );
              this.setMeasureCoachingScales(report);
            }
            if (existingCoachingFromDb) {
              if (Array.isArray(response.annotations)) {
                existingCoachingFromDb.annotations = response.annotations;
              }
              if (response.indskr_coachingrefno) {
                existingCoachingFromDb.indskr_coachingrefno = response.indskr_coachingrefno;
              }
              if (response.indskr_coachingduration != null) {
                existingCoachingFromDb.indskr_coachingduration = response.indskr_coachingduration;
              }
              if (response.indskr_coachingsessions != null) {
                existingCoachingFromDb.indskr_coachingsessions = response.indskr_coachingsessions;
              }
              // Persist the authoritative "Coaching By" fields from the per-record endpoint
              // so that PouchDB is correct even when the list-sync initial fetch omits them.
              if (response.indskr_coachingfor_value) {
                existingCoachingFromDb.indskr_coachingfor_value = response.indskr_coachingfor_value;
              }
              if (response.created_for) {
                existingCoachingFromDb.created_for = response.created_for;
              }
              if (response.created_for_firstname) {
                existingCoachingFromDb.created_for_firstname = response.created_for_firstname;
              }
              if (response.indskr_overallrating != null) {
                existingCoachingFromDb.indskr_overallrating = response.indskr_overallrating;
              }
              if (response.indskr_coachingtype != null) {
                existingCoachingFromDb.indskr_coachingtype = response.indskr_coachingtype;
              }
              if (response.indskr_contact !== undefined) {
                existingCoachingFromDb.indskr_contact = response.indskr_contact;
                existingCoachingFromDb.indskr_contactname = response.indskr_contactname;
              }
              if (response.indskr_account !== undefined) {
                existingCoachingFromDb.indskr_account = response.indskr_account;
                existingCoachingFromDb.indskr_accountname = response.indskr_accountname;
              }
              if (response.indskr_ratingssummary !== undefined) {
                existingCoachingFromDb.indskr_ratingssummary = response.indskr_ratingssummary;
              }
              if (response.indskr_recommendations !== undefined) {
                existingCoachingFromDb.indskr_recommendations = response.indskr_recommendations;
              }
              if (Array.isArray(response.meetings)) existingCoachingFromDb.meetings = response.meetings;
              if (Array.isArray(response.phonecalls)) existingCoachingFromDb.phonecalls = response.phonecalls;
              if (Array.isArray(response.procedureLogs)) existingCoachingFromDb.procedureLogs = response.procedureLogs;
              // Self-coaching fallback: persist indskr_coachingfor_value / created_for to
              // PouchDB when the per-record endpoint omits them, so the field remains correct
              // across app restarts and subsequent loads without needing another server call.
              if (this.isSelfCoaching && !existingCoachingFromDb.indskr_coachingfor_value) {
                existingCoachingFromDb.indskr_coachingfor_value = this.authService.user.systemUserID;
                existingCoachingFromDb.created_for = this.authService.user.displayName;
              }
              if (shouldSyncCategories) {
                existingCoachingFromDb.categories = report.categories;
              }
              this.disk.updateDocWithIdAndRev(existingCoachingFromDb);
            }
            this.selectedReport.next(report);
          }
          await this.uiService.dismissLoader();
        },
        async msg => {
          console.error("Error occurred while fetching coaching details of ", report.indskr_coachingreportid);
          this.checkCoachingError(msg, report);
          await this.uiService.dismissLoader();
        });
  }

  public async setActivityCoaching(data: Activity) {
    let filteredCoachings: Report[] = [];
    if (data && (data.isCompleted || data.isReopened)) {
      if (this.teamReportSubject.value.length > 0) {
        if (data instanceof PhoneActivity) {
          filteredCoachings = this.teamReportSubject.value.filter(coachingReport =>
            coachingReport.statuscode !== 1 && coachingReport.phonecalls.filter(activity => activity.indskr_activityid === data.ID).length > 0
          );
        } else if (data instanceof OrderActivity) {
          filteredCoachings = this.teamReportSubject.value.filter(coachingReport =>
            coachingReport.statuscode !== 1 && coachingReport.procedureLogs.filter(activity => activity.indskr_activityid === data.ID).length > 0
          );
        } else {
          filteredCoachings = this.teamReportSubject.value.filter(coachingReport =>
            coachingReport.statuscode !== 1 && coachingReport.meetings.filter(activity => activity.indskr_activityid === data.ID).length > 0
          );
        }
      }
    }
    this.activityCoachingDataSource.next(filteredCoachings);
  }

  private async checkCoachingError(err: any, coaching: Report) {
    if (err.hasOwnProperty("error") && err.error.errorCode == "RECORD_NOT_FOUND_404") {
      if (this.activeTab === 'myCoaching') {
        // A 404 from the myCoaching detail endpoint does NOT mean the record was deleted.
        // The backend endpoint may only serve coachings in statuscode = 1 (Open) and silently
        // return 404 once the trainer completes the self-coaching (statuscode = 548910004).
        // Do NOT remove the coaching from the list or PouchDB — the trainee still needs to
        // see it. Fall back to the PouchDB version so the details view opens instead of being
        // blank. The displayed statuscode may be stale (still 1/Open) until the backend
        // returns completed self-coachings in the GET_MY_COACHING_REPORT / GET_MY_COACHING_REPORTS
        // responses; that is a backend concern and should be raised with the backend team.
        const cached: Report = await this.disk.retrieve(coaching._id?.toString());
        this.selectedReport.next(cached ?? coaching);
      } else {
        // teamCoaching 404 = coaching truly removed from trainer's visible scope (scrap/delete).
        this.selectedReport.next(null);
        this.teamReportSubject.next(this.teamReportSubject.value
          .filter(data => data.indskr_coachingreportid !== coaching.indskr_coachingreportid));
        this.fiterReports();
        this.disk.remove(coaching._id.toString());
      }
    } else {
      this.retainPreviousCoachingState();
    }
  }

  public async uploadOfflineCoachingReports(isPartialUpload = false, maxRecordCountForPartialUpload = 10) {
    if (!isPartialUpload && this.deviceService.isOffline) return;
    const offlineCoachingReports = await this.disk.loadOfflineCoachingReports();
    const coachingReportsSyncInfo: EntitySyncInfo = {
      entityName: EntityNames.coachingReport,
      totalFailed: 0,
      totalSynced: 0,
      errors: [],
      syncStatus: true
    };
    if (offlineCoachingReports && offlineCoachingReports['coachingReports'] && Array.isArray(offlineCoachingReports['coachingReports']) && offlineCoachingReports['coachingReports'].length > 0) {
      try {
        let updatedRequestBody = offlineCoachingReports['coachingReports'];

        if (isPartialUpload) {
          if (offlineCoachingReports['eventRegResponse'].length > maxRecordCountForPartialUpload) {
            updatedRequestBody = JSON.parse(JSON.stringify(offlineCoachingReports['eventRegResponse']));
            updatedRequestBody = updatedRequestBody.splice(0, maxRecordCountForPartialUpload);
          }
        }
        updatedRequestBody.forEach(coaching => {
          if (!coaching.deleted) {
            if (coaching.statuscode === 2) {
              coaching.statuscode = 548910002
            }
            else if (coaching.statuscode === 3) {
              coaching.statuscode = 548910003;
            }
            else if (coaching.statuscode === 4) {
              coaching.statuscode = 548910001;
            }
            else if (coaching.statuscode === 5) {
              coaching.statuscode = 548910000;
            }
            if (coaching.indskr_shareddate && !isNumber(coaching.indskr_shareddate)) {
              coaching.indskr_shareddate = new Date(coaching.indskr_shareddate).getTime();
            }
            if (coaching.indskr_accepteddate && !isNumber(coaching.indskr_accepteddate)) {
              coaching.indskr_accepteddate = new Date(coaching.indskr_accepteddate).getTime();
            }
          }
        });
        const offlineCoachingsResponse = await this.coachingReportDataService.uploadOfflineCoachingReports(updatedRequestBody);
        for (let index = 0; index < offlineCoachingsResponse.length; index++) {
          let cResponse = offlineCoachingsResponse[index];
          if (!cResponse['errorId'] || cResponse['errorCode'] == "RECORD_NOT_FOUND_404") {
            let idx;
            offlineCoachingReports['coachingReports'].findIndex((a, index) => {
              if (a.offlineCoachingReportId && a.offlineCoachingReportId == cResponse['offlineCoachingReportId']) {
                idx = index;
              } else if (a.indskr_coachingreportid && a.indskr_coachingreportid == cResponse['indskr_coachingreportid']) {
                idx = index;
              }
            });
            if (idx >= 0) {
              let coaching = offlineCoachingReports['coachingReports'][idx];
              // Determine which subject owns this record by searching both,
              // independent of activeTab (upload is a background operation).
              const matchFn = (data: Report) =>
                data.indskr_coachingreportid === coaching.indskr_coachingreportid ||
                (data.offlineCoachingReportId && coaching.offlineCoachingReportId &&
                  data.offlineCoachingReportId === coaching.offlineCoachingReportId);

              let myReports = this.myReportSubject.value;
              let teamReports = this.teamReportSubject.value;
              let currentReport = myReports.find(matchFn);
              const isMyCoachingRecord = !!currentReport;
              if (!currentReport) {
                currentReport = teamReports.find(matchFn);
              }

              if (currentReport) {
                currentReport.statuscode = coaching.statuscode;
                currentReport.statusName = coaching.statusName;
                //offline scenario - currentReport did not have indskr_coachingreportid. To need to be updated with response from uploadOfflineCoachingReports.
                if (!currentReport.indskr_coachingreportid) {
                  currentReport.indskr_coachingreportid = cResponse.indskr_coachingreportid;
                }
                // The backend assigns indskr_coachingrefno when the record is created in
                // Dynamics. Copy it back so the ref no is visible immediately after the
                // offline coaching is uploaded, without waiting for the next delta sync.
                if (cResponse.indskr_coachingrefno) {
                  currentReport.indskr_coachingrefno = cResponse.indskr_coachingrefno;
                }
                if (isMyCoachingRecord) {
                  this.myReportSubject.next(myReports);
                } else {
                  this.teamReportSubject.next(teamReports);
                }
                // Refresh the details view if this coaching is currently open.
                if (this.selectedReport.value &&
                  (this.selectedReport.value.indskr_coachingreportid === currentReport.indskr_coachingreportid ||
                    this.selectedReport.value.offlineCoachingReportId === currentReport.offlineCoachingReportId)) {
                  this.selectedReport.next(currentReport);
                }
              }

              let idToBeUpdated: String = coaching.offlineCoachingReportId ? coaching.offlineCoachingReportId : coaching.indskr_coachingreportid; //To support old records
              this.deleteFromOfflineCoachingReportsIds(idToBeUpdated);
              await this.createOfflineCoachingReportInDB(updatedRequestBody, cResponse, coaching, isMyCoachingRecord);
              offlineCoachingReports['coachingReports'].splice(idx, 1);
              offlineCoachingReports['count']--
            }
            else {
              console.warn(`uploadOfflineCoachingReport: ID ${cResponse.offlineCoachingReportId} is not found from local db.`);
            }
            coachingReportsSyncInfo.totalSynced++;
          }
        }
      } catch (httpError) {
        this.deltaService.addSyncErrorToEntitySyncInfo(coachingReportsSyncInfo, this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.customerEvents.CAPTURE_EVENT_REGISTRATION_RESPONSE, httpError);
        coachingReportsSyncInfo.totalFailed += coachingReportsSyncInfo['count'];
      }
      this.deltaService.addEntitySyncInfo(coachingReportsSyncInfo, true);
      await this.disk.updateDocWithIdAndRev(offlineCoachingReports);

      // Track offline data count
      const newCount = offlineCoachingReports['coachingReports'].length - coachingReportsSyncInfo.totalSynced + coachingReportsSyncInfo.totalFailed
      this.disk.setOfflineDataCount(OFFLINE_DATA_COUNT_ENTITY_NAME.COACHING_REPORT, newCount > 0 ? newCount : 0);
    }
  }

  private async createOfflineCoachingReportInDB(updatedRequestBody: any[], cResponse: any, coaching: any, isMyCoachingRecord = false) {
    let reqIndex = updatedRequestBody.findIndex(offlineRequestCoaching =>
      (offlineRequestCoaching["offlineCoachingReportId"] === cResponse["offlineCoachingReportId"]) ||
      (offlineRequestCoaching["indskr_coachingreportid"] === cResponse["indskr_coachingreportid"])
    );
    if (!coaching.deleted && reqIndex >= 0) {
      let dbKey = "";
      // isMyCoachingRecord takes priority: a newly created offline self-coaching record
      // has _id="" so the _id-based check below would incorrectly fall to TEAM_COACHING.
      if (isMyCoachingRecord) {
        dbKey = DB_KEY_PREFIXES.MY_COACHING;
      } else if (!updatedRequestBody[reqIndex]["_id"] || updatedRequestBody[reqIndex]["_id"].includes(DB_KEY_PREFIXES.TEAM_COACHING)) {
        dbKey = DB_KEY_PREFIXES.TEAM_COACHING;
      } else {
        dbKey = DB_KEY_PREFIXES.MY_COACHING;
      }
      updatedRequestBody[reqIndex]["indskr_coachingreportid"] = cResponse["indskr_coachingreportid"];
      // Persist the server-assigned ref no so PouchDB holds it and the UI shows it
      // immediately — without this the field stays blank until the next delta sync.
      if (cResponse["indskr_coachingrefno"]) {
        updatedRequestBody[reqIndex]["indskr_coachingrefno"] = cResponse["indskr_coachingrefno"];
      }
      let coachingToBeCreated = [];
      coachingToBeCreated.push(updatedRequestBody[reqIndex]);
      await this.saveToDisk(false, dbKey, coachingToBeCreated);
    }
  }

  public async checkOfflineDataExists(): Promise<boolean> {
    const offlineCoachingReports = await this.disk.loadOfflineCoachingReports();
    const offlineDataCount = offlineCoachingReports && Array.isArray(offlineCoachingReports['coachingReports']) && offlineCoachingReports['coachingReports'].length > 0 ? offlineCoachingReports['coachingReports'].length : 0;
    this.disk.setOfflineDataCount(OFFLINE_DATA_COUNT_ENTITY_NAME.COACHING_REPORT, offlineDataCount);
    return offlineDataCount ? true : false;
  }


  public getCoachingDuration(report: Report): string {
    let duration: string = "";
    let days: any = this.dateTimeFormatsService.getDifferenceInDays(report.indskr_periodenddate, report.indskr_periodstartdate) + 1;
    let weeks: any = this.dateTimeFormatsService.getDifferenceInWeeks(report.indskr_periodenddate, report.indskr_periodstartdate);
    let months: any = this.dateTimeFormatsService.getDifferenceInMonths(report.indskr_periodenddate, report.indskr_periodstartdate);
    let years: any = this.dateTimeFormatsService.getDifferenceInYears(report.indskr_periodenddate, report.indskr_periodstartdate);
    if (years >= 1) {
      duration = years + "y"
    }
    else if (months >= 1) {
      duration = months + "m"
    }
    else if (weeks >= 1) {
      duration = weeks + "w"
    }
    else if (days >= 1) {
      duration = days + "d"
    }
    return duration;

  }

  private mapStatusCodeToStatusName(coaching: Report) {
    let shareFA: boolean = this.authService.hasFeatureAction(FeatureActionsMap.COACHING_SHARE);
    if (coaching.statuscode == 1) coaching.statusName = 'Open';
    else if (coaching.statuscode == 548910002 && shareFA) coaching.statusName = this.translate.instant("SHARED");
    else if (coaching.statuscode == 548910003 && shareFA) coaching.statusName = this.translate.instant("ACCEPTED");
    else if (coaching.statuscode == 548910001) coaching.statusName = this.translate.instant("FOR_REVIEW");
    else if (coaching.statuscode == 548910000) coaching.statusName = this.translate.instant("ACKNOWLEDGED")
  }

  public mapMyCoachingFieldsToSearchIndex(newCoaching: Report) {
    this.mapStatusCodeToStatusName(newCoaching);
    if (!this.searchConfigService.isConfigInitiated) {
      this.searchConfigService.initSearchConfigs();
      this.searchConfigService.isConfigInitiated = true;
    }
    if (newCoaching.statusName && !this.searchConfigService.myCoachingSearchIndexesConfig.find(config => config.categoryName == 'Status').values.some(o => o == newCoaching.statusName)) {
      this.searchConfigService.myCoachingSearchIndexesConfig.find(config => config.categoryName == 'Status').values.push(newCoaching.statusName);
    }
    if (newCoaching.created_by && !this.searchConfigService.myCoachingSearchIndexesConfig.find(config => config.categoryName == 'Coaching By').values.some(o => o == newCoaching.created_by.toString())) {
      this.searchConfigService.myCoachingSearchIndexesConfig.find(config => config.categoryName == 'Coaching By').values.push(newCoaching.created_by.toString());
    }
  }

  public mapTeamCoachingFieldsToSearchIndex(newCoaching: Report) {
    this.mapStatusCodeToStatusName(newCoaching);
    if (!this.searchConfigService.isConfigInitiated) {
      this.searchConfigService.initSearchConfigs();
      this.searchConfigService.isConfigInitiated = true;
    }
    if (newCoaching.statusName && !this.searchConfigService.teamCoachingSearchIndexesConfig.find(config => config.categoryName == 'Status').values.some(o => o == newCoaching.statusName)) {
      this.searchConfigService.teamCoachingSearchIndexesConfig.find(config => config.categoryName == 'Status').values.push(newCoaching.statusName);
    }
    if (newCoaching.created_for && !this.searchConfigService.teamCoachingSearchIndexesConfig.find(config => config.categoryName == 'Users').values.some(o => o == newCoaching.created_for.toString())) {
      this.searchConfigService.teamCoachingSearchIndexesConfig.find(config => config.categoryName == 'Users').values.push(newCoaching.created_for.toString());
    }
  }

  public getMyRecentSearches() {
    this.disk.retrieve(DB_KEY_PREFIXES.MY_COACHING_RECENT_SEARCHES, true).then((doc) => {
      if (doc && doc.raw) {
        this.recentSearches = doc.raw
      }
      else {
        this.recentSearches = [];
      }
    })
  }

  public getTeamRecentSearches() {
    this.disk.retrieve(DB_KEY_PREFIXES.TEAM_COACHING_RECENT_SEARCHES, true).then((doc) => {
      if (doc && doc.raw) {
        this.teamRecentSearches = doc.raw
      }
      else {
        this.teamRecentSearches = [];
      }
    })
  }

  public async loadCoachingNoteFromDB() {
    await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_NOTE).then((data:any[]) => {
      //check for delete true
      let notes = data
      if(!isEmpty(notes)){
         this.coachingReportDataService.saveCoachingNotes(data).then(
           this.disk.deleteAllFromDbUsingAlldocsQuery(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_NOTE)
         );
      }
    });
  }
  sortListByFieldName(options, fieldName: string) {
    if (isEmpty(options)) return [];
    return options.sort((a, b) => {
      let nameA: string = a[fieldName], nameB: string = b[fieldName];
      if (!nameA || !nameB) return 1;
      nameA = nameA.toLowerCase();
      nameB = nameB.toLowerCase();
      if (nameA < nameB)
        return -1;
      if (nameA >= nameB)
        return 1;
    });
  }

  public makeStatus(statuscode: number): string {
    if (isNaN(statuscode)) return '';
    let coachingStatus;
    coachingStatus = this.translate.instant(CoachingReportStatus["Status_" + statuscode]);
    return coachingStatus;

  }

  public getTertiaryInfo(report: Report, sortBy) {
    let str: string = '';

    if (sortBy) {
      switch (sortBy.value) {
        case 'indskr_shareddate':
          str = report.indskr_shareddate ? this.getFormattedAndLocalisedDate(new Date(report.indskr_shareddate)) : this.translate.instant('NO_SHARED_DATE');
          break;
        case 'indskr_accepteddate':
          str = report.indskr_accepteddate ? this.getFormattedAndLocalisedDate(new Date(report.indskr_accepteddate)) : this.translate.instant('NO_ACCEPTED_DATE');
          break;
        case 'indskr_dateforreview':
          str = report.indskr_dateforreview ? this.getFormattedAndLocalisedDate(new Date(report.indskr_dateforreview)) : this.translate.instant('NO_FORREVIEW_DATE');
          break;
        case 'indskr_dateacknowledged':
          str = report.indskr_dateacknowledged ? this.getFormattedAndLocalisedDate(new Date(report.indskr_dateacknowledged)) : this.translate.instant('NO_ACKNOWLEDGED_DATE');
          break;
        case 'createdon':
          str = (report.createdon && report.createdon > 0) ? this.getFormattedAndLocalisedDate(new Date(report.createdon)) : this.translate.instant('NO_COACHING_DATE');
          break;
      }
    } else {
      console.error('no sort option found');
  }
    return str;
  }

  private getFormattedAndLocalisedDate(value: any) {
    return this.datePipe.transform(value, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
  }

  async syncCoachingPlanActivities(forceFullSync) {
    // let offlineFallback: boolean = this.device.isOffline || loadFromDbOnly;

      const syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_COACHING_PLANS_ACTIVITY);
      const isInitialSync =  forceFullSync || !syncState || !syncState.lastUpdatedTime;;
      let lastUpdatedTime = syncState?.lastUpdatedTime;

      const coachingPlanActivity: EntitySyncInfo = {
        entityName: EntityNames.coachingPlanActivity,
        totalFailed: 0,
        totalSynced: 0,
        errors: [],
        syncStatus: true
      };
      if (isInitialSync) {
       await this.coachingPlanActivityInitialSync();
      } else {
       await this.coachingPlanActivityDeltaSync(lastUpdatedTime);
      }
      const newLastUpdatedTime = new Date().getTime().toString();
      syncState.lastUpdatedTime = newLastUpdatedTime;
      await this.disk.updateSyncState(syncState);
      if (Array.isArray(this.coachingPlansActivity)) {
        coachingPlanActivity.totalSynced = this.coachingPlansActivity.length;
      }
      this.deltaService.addEntitySyncInfo(coachingPlanActivity);

  }

  private getPlanUserAccessCondition(): string {
    const hasSelfCoachingFA = this.authService.hasFeatureAction(FeatureActionsMap.SELF_COACHING);
    return hasSelfCoachingFA
      ? `<filter type="or">
          <condition entityname="an" attribute="indskr_trainee" operator="eq-userid" />
          <condition entityname="ab" attribute="systemuserid" operator="eq-userid" />
        </filter>`
      : `<condition entityname="ab" attribute="systemuserid" operator="eq-userid" />`;
  }

  coachingPlanActivityInitialSync(){
    let fetchXml = fetchQueries.coaching.coachingPlanAtivity;
    fetchXml = fetchXml.replace('{PlanUserAccessCondition}', this.getPlanUserAccessCondition());
    fetchXml = fetchXml.replace('{deltaSyncCond}', '');
    this.coachingReportDataService.getCoachingPlanActivity(fetchXml).then(res=>{
        console.log(this.sortCoachingPlanIdWithActivityId(res));
        this.coachingPlansActivity = this.sortCoachingPlanIdWithActivityId(res);
    })
  }
  coachingPlanActivityDeltaSync(lastUpdatedTime){
    let fetchXml = fetchQueries.coaching.coachingPlanAtivity;
    fetchXml = fetchXml.replace('{PlanUserAccessCondition}', this.getPlanUserAccessCondition());
    const deltaSyncFilter = `<condition attribute="modifiedon" operator="ge" value="` + new Date(Number(lastUpdatedTime)).toISOString() + `" />`
    fetchXml = fetchXml.replace('{deltaSyncCond}', deltaSyncFilter);
    this.coachingReportDataService.getCoachingPlanActivity(fetchXml).then(res=>{
        console.log(this.sortCoachingPlanIdWithActivityId(res));

    })
  }
  getAllActivity(){
    this.getTeamCoachingActivities(true).subscribe((res) => {
      res = uniqBy(res, 'indskr_activityid');
      // let activeActivityIds ;
      // let relatedActivity ;
      // const coachPlanActivityGroupBy = this.sortCoachingPlanIdWithActivityId(this.coachingPlansActivity);
      // let activity = coachPlanActivityGroupBy[this.selectedReport.value.indskr_coachingplan];
      // if(activity.length>1){
      //   activeActivityIds = activity.map(res=>res["indskr_meeting_value"] || res["indskr_procedurelog_value"]);
      // }
      // activeActivityIds.forEach(data=>{
      //     let act = res.find(x=>x.indskr_activityid==data)
      //     if(act) relatedActivity.push(act);
      // })
    this.allActivity = res;
    });
  }
  private async getCoachingPlanActivities(forceFullSync: boolean) {
    let fetchXml = fetchQueries.coaching.coachingPlanAtivity;
    fetchXml = fetchXml.replace('{PlanUserAccessCondition}', this.getPlanUserAccessCondition());

    const syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_COACHING_PLANS_ACTIVITY);
    const isInitialSync = forceFullSync || !syncState || !syncState.lastUpdatedTime;
    const newLastUpdatedTime = new Date().getTime();

    const coachingPlanSyncInfo: EntitySyncInfo = {
      entityName: EntityNames.coachingPlanActivity,
      totalFailed: 0,
      totalSynced: 0,
      errors: [],
      syncStatus: true
    };
    if (isInitialSync) {
      this.coachingPlansActivity = [];
      fetchXml = fetchXml.replace('{deltaSyncCond}', '');
      try{
        Promise.all([
          this.disk.deleteAllFromDbUsingAlldocsQuery(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_COACHING_PLANS_ACTIVITY),
          // this.deleteCoachingPlans([], true),
        ]);
      }catch(error) {
        console.error("Failed to delete coachingplans Activity ", error);
      }
    }
    else {
      const deltaSyncFilter = `<condition attribute="modifiedon" operator="ge" value="` + new Date(syncState.lastUpdatedTime).toISOString() + `" />`
      fetchXml = fetchXml.replace('{deltaSyncCond}', deltaSyncFilter);
      if (!this.isInitialMappingDoneForActivity) {
        await this.loadCoachingPlansActivityFromDB();
        this.isInitialMappingDoneForActivity = true;
      }
    }

    await this.coachingReportDataService.getCoachingPlanActivity(fetchXml).then(
      async (data:CoachingPlanActivity[]) => {
        if (!isEmpty(data)) {
          console.log("Saving coaching plans Activity to disk...");
          this.removeUnderscoreFromDynamicsResp(data);
          if (isInitialSync) {
            await this.saveCoachingPlansActivityToDisk(data);
          } else {
            await this.saveDeltaCoachingPlansActivityToDisk(data);
          }
        }
        this.isInitialMappingDoneForActivity = true;
        syncState.lastUpdatedTime = newLastUpdatedTime;
        await this.disk.updateSyncState(syncState);
        if (Array.isArray(data)) {
          coachingPlanSyncInfo.totalSynced = data.length;
        }
        this.deltaService.addEntitySyncInfo(coachingPlanSyncInfo);
      }).catch(err => {
        console.error("Error occurred while fetching coachingplans...", err)
        this.deltaService.addSyncErrorToEntitySyncInfo(coachingPlanSyncInfo, 'indskr_coachingplans', err);
        this.deltaService.addEntitySyncInfo(coachingPlanSyncInfo);
      });
  }

  sortCoachingPlanIdWithActivityId(data){
    return data.reduce((acc, activity) => {
      const key = activity["indskr_coachingplan_value"];
      if (!acc[key]) {
          acc[key] = [];
      }
      acc[key].push(activity);
      return acc;
    }, {});
  }

}
